var runAnimation = false;

// glMatrix.js
// glMatrix v0.9.5
const glMatrixArrayType =
    typeof Float32Array != "undefined"
        ? Float32Array
        : typeof WebGLFloatArray != "undefined"
        ? WebGLFloatArray
        : Array;
var vec3 = {};

vec3.create = function (a) {
    var b = new glMatrixArrayType(3);
    if (a) {
        b[0] = a[0];
        b[1] = a[1];
        b[2] = a[2];
    }
    return b;
};

vec3.set = function (a, b) {
    b[0] = a[0];
    b[1] = a[1];
    b[2] = a[2];
    return b;
};

vec3.add = function (a, b, c) {
    if (!c || a == c) {
        a[0] += b[0];
        a[1] += b[1];
        a[2] += b[2];
        return a;
    }
    c[0] = a[0] + b[0];
    c[1] = a[1] + b[1];
    c[2] = a[2] + b[2];
    return c;
};

vec3.subtract = function (a, b, c) {
    if (!c || a == c) {
        a[0] -= b[0];
        a[1] -= b[1];
        a[2] -= b[2];
        return a;
    }
    c[0] = a[0] - b[0];
    c[1] = a[1] - b[1];
    c[2] = a[2] - b[2];
    return c;
};

vec3.negate = function (a, b) {
    b || (b = a);
    b[0] = -a[0];
    b[1] = -a[1];
    b[2] = -a[2];
    return b;
};

vec3.scale = function (a, b, c) {
    if (!c || a == c) {
        a[0] *= b;
        a[1] *= b;
        a[2] *= b;
        return a;
    }
    c[0] = a[0] * b;
    c[1] = a[1] * b;
    c[2] = a[2] * b;
    return c;
};

vec3.normalize = function (a, b) {
    b || (b = a);
    var c = a[0],
        d = a[1],
        e = a[2],
        g = Math.sqrt(c * c + d * d + e * e);
    if (g) {
        if (g == 1) {
            b[0] = c;
            b[1] = d;
            b[2] = e;
            return b;
        }
    } else {
        b[0] = 0;
        b[1] = 0;
        b[2] = 0;
        return b;
    }
    g = 1 / g;
    b[0] = c * g;
    b[1] = d * g;
    b[2] = e * g;
    return b;
};

vec3.cross = function (a, b, c) {
    c || (c = a);
    var d = a[0],
        e = a[1];
    a = a[2];
    var g = b[0],
        f = b[1];
    b = b[2];
    c[0] = e * b - a * f;
    c[1] = a * g - d * b;
    c[2] = d * f - e * g;
    return c;
};

vec3.length = function (a) {
    var b = a[0],
        c = a[1];
    a = a[2];
    return Math.sqrt(b * b + c * c + a * a);
};
vec3.dot = function (a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
};
vec3.mul = function (a, b, c) {
    c || (c = a);
    c[0] = a[0] * b[0];
    c[1] = a[1] * b[1];
    c[2] = a[2] * b[2];

    return c;
};
vec3.direction = function (a, b, c) {
    c || (c = a);
    var d = a[0] - b[0],
        e = a[1] - b[1];
    a = a[2] - b[2];
    b = Math.sqrt(d * d + e * e + a * a);
    if (!b) {
        c[0] = 0;
        c[1] = 0;
        c[2] = 0;
        return c;
    }
    b = 1 / b;
    c[0] = d * b;
    c[1] = e * b;
    c[2] = a * b;
    return c;
};

vec3.lerp = function (a, b, c, d) {
    d || (d = a);
    d[0] = a[0] + c * (b[0] - a[0]);
    d[1] = a[1] + c * (b[1] - a[1]);
    d[2] = a[2] + c * (b[2] - a[2]);
    return d;
};
vec3.toMat3 = function (a, b) {
    b || (b = mat3.create());
    b[0] = a[0];
    b[1] = 0;
    b[2] = 0;
    b[3] = 0;
    b[4] = a[1];
    b[5] = 0;
    b[6] = 0;
    b[7] = 0;
    b[8] = a[2];
    return b;
};
vec3.str = function (a) {
    return "[" + a[0] + ", " + a[1] + ", " + a[2] + "]";
};
var mat3 = {};
mat3.create = function (a) {
    var b = new glMatrixArrayType(9);
    if (a) {
        b[0] = a[0];
        b[1] = a[1];
        b[2] = a[2];
        b[3] = a[3];
        b[4] = a[4];
        b[5] = a[5];
        b[6] = a[6];
        b[7] = a[7];
        b[8] = a[8];
        b[9] = a[9];
    }
    return b;
};
mat3.set = function (a, b) {
    b[0] = a[0];
    b[1] = a[1];
    b[2] = a[2];
    b[3] = a[3];
    b[4] = a[4];
    b[5] = a[5];
    b[6] = a[6];
    b[7] = a[7];
    b[8] = a[8];
    return b;
};
mat3.identity = function (a) {
    a[0] = 1;
    a[1] = 0;
    a[2] = 0;
    a[3] = 0;
    a[4] = 1;
    a[5] = 0;
    a[6] = 0;
    a[7] = 0;
    a[8] = 1;
    return a;
};
mat3.transpose = function (a, b) {
    if (!b || a == b) {
        var c = a[1],
            d = a[2],
            e = a[5];
        a[1] = a[3];
        a[2] = a[6];
        a[3] = c;
        a[5] = a[7];
        a[6] = d;
        a[7] = e;
        return a;
    }
    b[0] = a[0];
    b[1] = a[3];
    b[2] = a[6];
    b[3] = a[1];
    b[4] = a[4];
    b[5] = a[7];
    b[6] = a[2];
    b[7] = a[5];
    b[8] = a[8];
    return b;
};

mat3.toMat4 = function (a, b) {
    b || (b = mat4.create());
    b[0] = a[0];
    b[1] = a[1];
    b[2] = a[2];
    b[3] = 0;
    b[4] = a[3];
    b[5] = a[4];
    b[6] = a[5];
    b[7] = 0;
    b[8] = a[6];
    b[9] = a[7];
    b[10] = a[8];
    b[11] = 0;
    b[12] = 0;
    b[13] = 0;
    b[14] = 0;
    b[15] = 1;
    return b;
};

mat3.str = function (a) {
    return (
        "[" +
        a[0] +
        ", " +
        a[1] +
        ", " +
        a[2] +
        ", " +
        a[3] +
        ", " +
        a[4] +
        ", " +
        a[5] +
        ", " +
        a[6] +
        ", " +
        a[7] +
        ", " +
        a[8] +
        "]"
    );
};

mat3.toVec3 = function (a, b) {
    b || (b = vec3.create());
    b[0] = a[0];
    b[1] = a[4];
    b[2] = a[8];

    return b;
};
var mat4 = {};
mat4.create = function (a) {
    var b = new glMatrixArrayType(16);
    if (a) {
        b[0] = a[0];
        b[1] = a[1];
        b[2] = a[2];
        b[3] = a[3];
        b[4] = a[4];
        b[5] = a[5];
        b[6] = a[6];
        b[7] = a[7];
        b[8] = a[8];
        b[9] = a[9];
        b[10] = a[10];
        b[11] = a[11];
        b[12] = a[12];
        b[13] = a[13];
        b[14] = a[14];
        b[15] = a[15];
    }
    return b;
};

mat4.set = function (a, b) {
    b[0] = a[0];
    b[1] = a[1];
    b[2] = a[2];
    b[3] = a[3];
    b[4] = a[4];
    b[5] = a[5];
    b[6] = a[6];
    b[7] = a[7];
    b[8] = a[8];
    b[9] = a[9];
    b[10] = a[10];
    b[11] = a[11];
    b[12] = a[12];
    b[13] = a[13];
    b[14] = a[14];
    b[15] = a[15];
    return b;
};
mat4.identity = function (a) {
    a[0] = 1;
    a[1] = 0;
    a[2] = 0;
    a[3] = 0;
    a[4] = 0;
    a[5] = 1;
    a[6] = 0;
    a[7] = 0;
    a[8] = 0;
    a[9] = 0;
    a[10] = 1;
    a[11] = 0;
    a[12] = 0;
    a[13] = 0;
    a[14] = 0;
    a[15] = 1;
    return a;
};
mat4.transpose = function (a, b) {
    if (!b || a == b) {
        var c = a[1],
            d = a[2],
            e = a[3],
            g = a[6],
            f = a[7],
            h = a[11];
        a[1] = a[4];
        a[2] = a[8];
        a[3] = a[12];
        a[4] = c;
        a[6] = a[9];
        a[7] = a[13];
        a[8] = d;
        a[9] = g;
        a[11] = a[14];
        a[12] = e;
        a[13] = f;
        a[14] = h;
        return a;
    }
    b[0] = a[0];
    b[1] = a[4];
    b[2] = a[8];
    b[3] = a[12];
    b[4] = a[1];
    b[5] = a[5];
    b[6] = a[9];
    b[7] = a[13];
    b[8] = a[2];
    b[9] = a[6];
    b[10] = a[10];
    b[11] = a[14];
    b[12] = a[3];
    b[13] = a[7];
    b[14] = a[11];
    b[15] = a[15];
    return b;
};

mat4.determinant = function (a) {
    var b = a[0],
        c = a[1],
        d = a[2],
        e = a[3],
        g = a[4],
        f = a[5],
        h = a[6],
        i = a[7],
        j = a[8],
        k = a[9],
        l = a[10],
        o = a[11],
        m = a[12],
        n = a[13],
        p = a[14];
    a = a[15];
    return (
        m * k * h * e -
        j * n * h * e -
        m * f * l * e +
        g * n * l * e +
        j * f * p * e -
        g * k * p * e -
        m * k * d * i +
        j * n * d * i +
        m * c * l * i -
        b * n * l * i -
        j * c * p * i +
        b * k * p * i +
        m * f * d * o -
        g * n * d * o -
        m * c * h * o +
        b * n * h * o +
        g * c * p * o -
        b * f * p * o -
        j * f * d * a +
        g * k * d * a +
        j * c * h * a -
        b * k * h * a -
        g * c * l * a +
        b * f * l * a
    );
};
mat4.inverse = function (a, b) {
    b || (b = a);
    var c = a[0],
        d = a[1],
        e = a[2],
        g = a[3],
        f = a[4],
        h = a[5],
        i = a[6],
        j = a[7],
        k = a[8],
        l = a[9],
        o = a[10],
        m = a[11],
        n = a[12],
        p = a[13],
        r = a[14],
        s = a[15],
        A = c * h - d * f,
        B = c * i - e * f,
        t = c * j - g * f,
        u = d * i - e * h,
        v = d * j - g * h,
        w = e * j - g * i,
        x = k * p - l * n,
        y = k * r - o * n,
        z = k * s - m * n,
        C = l * r - o * p,
        D = l * s - m * p,
        E = o * s - m * r,
        q = 1 / (A * E - B * D + t * C + u * z - v * y + w * x);
    b[0] = (h * E - i * D + j * C) * q;
    b[1] = (-d * E + e * D - g * C) * q;
    b[2] = (p * w - r * v + s * u) * q;
    b[3] = (-l * w + o * v - m * u) * q;
    b[4] = (-f * E + i * z - j * y) * q;
    b[5] = (c * E - e * z + g * y) * q;
    b[6] = (-n * w + r * t - s * B) * q;
    b[7] = (k * w - o * t + m * B) * q;
    b[8] = (f * D - h * z + j * x) * q;
    b[9] = (-c * D + d * z - g * x) * q;
    b[10] = (n * v - p * t + s * A) * q;
    b[11] = (-k * v + l * t - m * A) * q;
    b[12] = (-f * C + h * y - i * x) * q;
    b[13] = (c * C - d * y + e * x) * q;
    b[14] = (-n * u + p * B - r * A) * q;
    b[15] = (k * u - l * B + o * A) * q;
    return b;
};
mat4.toRotationMat = function (a, b) {
    b || (b = mat4.create());
    b[0] = a[0];
    b[1] = a[1];
    b[2] = a[2];
    b[3] = a[3];
    b[4] = a[4];
    b[5] = a[5];
    b[6] = a[6];
    b[7] = a[7];
    b[8] = a[8];
    b[9] = a[9];
    b[10] = a[10];
    b[11] = a[11];
    b[12] = 0;
    b[13] = 0;
    b[14] = 0;
    b[15] = 1;
    return b;
};
mat4.toMat3 = function (a, b) {
    b || (b = mat3.create());
    b[0] = a[0];
    b[1] = a[1];
    b[2] = a[2];
    b[3] = a[4];
    b[4] = a[5];
    b[5] = a[6];
    b[6] = a[8];
    b[7] = a[9];
    b[8] = a[10];
    return b;
};
mat4.toInverseMat3 = function (a, b) {
    var c = a[0],
        d = a[1],
        e = a[2],
        g = a[4],
        f = a[5],
        h = a[6],
        i = a[8],
        j = a[9],
        k = a[10],
        l = k * f - h * j,
        o = -k * g + h * i,
        m = j * g - f * i,
        n = c * l + d * o + e * m;
    if (!n) return null;
    n = 1 / n;
    b || (b = mat3.create());
    b[0] = l * n;
    b[1] = (-k * d + e * j) * n;
    b[2] = (h * d - e * f) * n;
    b[3] = o * n;
    b[4] = (k * c - e * i) * n;
    b[5] = (-h * c + e * g) * n;
    b[6] = m * n;
    b[7] = (-j * c + d * i) * n;
    b[8] = (f * c - d * g) * n;
    return b;
};

mat4.multiply = function (a, b, c) {
    c || (c = a);
    var d = a[0],
        e = a[1],
        g = a[2],
        f = a[3],
        h = a[4],
        i = a[5],
        j = a[6],
        k = a[7],
        l = a[8],
        o = a[9],
        m = a[10],
        n = a[11],
        p = a[12],
        r = a[13],
        s = a[14];
    a = a[15];
    var A = b[0],
        B = b[1],
        t = b[2],
        u = b[3],
        v = b[4],
        w = b[5],
        x = b[6],
        y = b[7],
        z = b[8],
        C = b[9],
        D = b[10],
        E = b[11],
        q = b[12],
        F = b[13],
        G = b[14];
    b = b[15];
    c[0] = A * d + B * h + t * l + u * p;
    c[1] = A * e + B * i + t * o + u * r;
    c[2] = A * g + B * j + t * m + u * s;
    c[3] = A * f + B * k + t * n + u * a;
    c[4] = v * d + w * h + x * l + y * p;
    c[5] = v * e + w * i + x * o + y * r;
    c[6] = v * g + w * j + x * m + y * s;
    c[7] = v * f + w * k + x * n + y * a;
    c[8] = z * d + C * h + D * l + E * p;
    c[9] = z * e + C * i + D * o + E * r;
    c[10] = z * g + C * j + D * m + E * s;
    c[11] = z * f + C * k + D * n + E * a;
    c[12] = q * d + F * h + G * l + b * p;
    c[13] = q * e + F * i + G * o + b * r;
    c[14] = q * g + F * j + G * m + b * s;
    c[15] = q * f + F * k + G * n + b * a;
    return c;
};

mat4.multiplyVec3 = function (a, b, c) {
    c || (c = b);
    var d = b[0],
        e = b[1];
    b = b[2];
    c[0] = a[0] * d + a[4] * e + a[8] * b + a[12];
    c[1] = a[1] * d + a[5] * e + a[9] * b + a[13];
    c[2] = a[2] * d + a[6] * e + a[10] * b + a[14];
    return c;
};
mat4.multiplyVec4 = function (a, b, c) {
    c || (c = b);
    var d = b[0],
        e = b[1],
        g = b[2];
    b = b[3];
    c[0] = a[0] * d + a[4] * e + a[8] * g + a[12] * b;
    c[1] = a[1] * d + a[5] * e + a[9] * g + a[13] * b;
    c[2] = a[2] * d + a[6] * e + a[10] * g + a[14] * b;
    c[3] = a[3] * d + a[7] * e + a[11] * g + a[15] * b;
    return c;
};
mat4.translate = function (a, b, c) {
    var d = b[0],
        e = b[1];
    b = b[2];
    if (!c || a == c) {
        a[12] = a[0] * d + a[4] * e + a[8] * b + a[12];
        a[13] = a[1] * d + a[5] * e + a[9] * b + a[13];
        a[14] = a[2] * d + a[6] * e + a[10] * b + a[14];
        a[15] = a[3] * d + a[7] * e + a[11] * b + a[15];
        return a;
    }
    var g = a[0],
        f = a[1],
        h = a[2],
        i = a[3],
        j = a[4],
        k = a[5],
        l = a[6],
        o = a[7],
        m = a[8],
        n = a[9],
        p = a[10],
        r = a[11];
    c[0] = g;
    c[1] = f;
    c[2] = h;
    c[3] = i;
    c[4] = j;
    c[5] = k;
    c[6] = l;
    c[7] = o;
    c[8] = m;
    c[9] = n;
    c[10] = p;
    c[11] = r;
    c[12] = g * d + j * e + m * b + a[12];
    c[13] = f * d + k * e + n * b + a[13];
    c[14] = h * d + l * e + p * b + a[14];
    c[15] = i * d + o * e + r * b + a[15];
    return c;
};
mat4.scale = function (a, b, c) {
    var d = b[0],
        e = b[1];
    b = b[2];
    if (!c || a == c) {
        a[0] *= d;
        a[1] *= d;
        a[2] *= d;
        a[3] *= d;
        a[4] *= e;
        a[5] *= e;
        a[6] *= e;
        a[7] *= e;
        a[8] *= b;
        a[9] *= b;
        a[10] *= b;
        a[11] *= b;
        return a;
    }
    c[0] = a[0] * d;
    c[1] = a[1] * d;
    c[2] = a[2] * d;
    c[3] = a[3] * d;
    c[4] = a[4] * e;
    c[5] = a[5] * e;
    c[6] = a[6] * e;
    c[7] = a[7] * e;
    c[8] = a[8] * b;
    c[9] = a[9] * b;
    c[10] = a[10] * b;
    c[11] = a[11] * b;
    c[12] = a[12];
    c[13] = a[13];
    c[14] = a[14];
    c[15] = a[15];
    return c;
};
mat4.rotate = function (a, b, c, d) {
    var e = c[0],
        g = c[1];
    c = c[2];
    var f = Math.sqrt(e * e + g * g + c * c);
    if (!f) return null;
    if (f != 1) {
        f = 1 / f;
        e *= f;
        g *= f;
        c *= f;
    }
    var h = Math.sin(b),
        i = Math.cos(b),
        j = 1 - i;
    b = a[0];
    f = a[1];
    var k = a[2],
        l = a[3],
        o = a[4],
        m = a[5],
        n = a[6],
        p = a[7],
        r = a[8],
        s = a[9],
        A = a[10],
        B = a[11],
        t = e * e * j + i,
        u = g * e * j + c * h,
        v = c * e * j - g * h,
        w = e * g * j - c * h,
        x = g * g * j + i,
        y = c * g * j + e * h,
        z = e * c * j + g * h;
    e = g * c * j - e * h;
    g = c * c * j + i;
    if (d) {
        if (a != d) {
            d[12] = a[12];
            d[13] = a[13];
            d[14] = a[14];
            d[15] = a[15];
        }
    } else d = a;
    d[0] = b * t + o * u + r * v;
    d[1] = f * t + m * u + s * v;
    d[2] = k * t + n * u + A * v;
    d[3] = l * t + p * u + B * v;
    d[4] = b * w + o * x + r * y;
    d[5] = f * w + m * x + s * y;
    d[6] = k * w + n * x + A * y;
    d[7] = l * w + p * x + B * y;
    d[8] = b * z + o * e + r * g;
    d[9] = f * z + m * e + s * g;
    d[10] = k * z + n * e + A * g;
    d[11] = l * z + p * e + B * g;
    return d;
};
mat4.rotateX = function (a, b, c) {
    var d = Math.sin(b);
    b = Math.cos(b);
    var e = a[4],
        g = a[5],
        f = a[6],
        h = a[7],
        i = a[8],
        j = a[9],
        k = a[10],
        l = a[11];
    if (c) {
        if (a != c) {
            c[0] = a[0];
            c[1] = a[1];
            c[2] = a[2];
            c[3] = a[3];
            c[12] = a[12];
            c[13] = a[13];
            c[14] = a[14];
            c[15] = a[15];
        }
    } else c = a;
    c[4] = e * b + i * d;
    c[5] = g * b + j * d;
    c[6] = f * b + k * d;
    c[7] = h * b + l * d;
    c[8] = e * -d + i * b;
    c[9] = g * -d + j * b;
    c[10] = f * -d + k * b;
    c[11] = h * -d + l * b;
    return c;
};
mat4.rotateY = function (a, b, c) {
    var d = Math.sin(b);
    b = Math.cos(b);
    var e = a[0],
        g = a[1],
        f = a[2],
        h = a[3],
        i = a[8],
        j = a[9],
        k = a[10],
        l = a[11];
    if (c) {
        if (a != c) {
            c[4] = a[4];
            c[5] = a[5];
            c[6] = a[6];
            c[7] = a[7];
            c[12] = a[12];
            c[13] = a[13];
            c[14] = a[14];
            c[15] = a[15];
        }
    } else c = a;
    c[0] = e * b + i * -d;
    c[1] = g * b + j * -d;
    c[2] = f * b + k * -d;
    c[3] = h * b + l * -d;
    c[8] = e * d + i * b;
    c[9] = g * d + j * b;
    c[10] = f * d + k * b;
    c[11] = h * d + l * b;
    return c;
};
mat4.rotateZ = function (a, b, c) {
    var d = Math.sin(b);
    b = Math.cos(b);
    var e = a[0],
        g = a[1],
        f = a[2],
        h = a[3],
        i = a[4],
        j = a[5],
        k = a[6],
        l = a[7];
    if (c) {
        if (a != c) {
            c[8] = a[8];
            c[9] = a[9];
            c[10] = a[10];
            c[11] = a[11];
            c[12] = a[12];
            c[13] = a[13];
            c[14] = a[14];
            c[15] = a[15];
        }
    } else c = a;
    c[0] = e * b + i * d;
    c[1] = g * b + j * d;
    c[2] = f * b + k * d;
    c[3] = h * b + l * d;
    c[4] = e * -d + i * b;
    c[5] = g * -d + j * b;
    c[6] = f * -d + k * b;
    c[7] = h * -d + l * b;
    return c;
};
mat4.frustum = function (a, b, c, d, e, g, f) {
    f || (f = mat4.create());
    var h = b - a,
        i = d - c,
        j = g - e;
    f[0] = (e * 2) / h;
    f[1] = 0;
    f[2] = 0;
    f[3] = 0;
    f[4] = 0;
    f[5] = (e * 2) / i;
    f[6] = 0;
    f[7] = 0;
    f[8] = (b + a) / h;
    f[9] = (d + c) / i;
    f[10] = -(g + e) / j;
    f[11] = -1;
    f[12] = 0;
    f[13] = 0;
    f[14] = -(g * e * 2) / j;
    f[15] = 0;
    return f;
};
mat4.perspective = function (a, b, c, d, e) {
    a = c * Math.tan((a * Math.PI) / 360);
    b = a * b;
    return mat4.frustum(-b, b, -a, a, c, d, e);
};
mat4.ortho = function (a, b, c, d, e, g, f) {
    f || (f = mat4.create());
    var h = b - a,
        i = d - c,
        j = g - e;
    f[0] = 2 / h;
    f[1] = 0;
    f[2] = 0;
    f[3] = 0;
    f[4] = 0;
    f[5] = 2 / i;
    f[6] = 0;
    f[7] = 0;
    f[8] = 0;
    f[9] = 0;
    f[10] = -2 / j;
    f[11] = 0;
    f[12] = -(a + b) / h;
    f[13] = -(d + c) / i;
    f[14] = -(g + e) / j;
    f[15] = 1;
    return f;
};
mat4.lookAt = function (a, b, c, d) {
    d || (d = mat4.create());
    var e = a[0],
        g = a[1];
    a = a[2];
    var f = c[0],
        h = c[1],
        i = c[2];
    c = b[1];
    var j = b[2];
    if (e == b[0] && g == c && a == j) return mat4.identity(d);
    var k, l, o, m;
    c = e - b[0];
    j = g - b[1];
    b = a - b[2];
    m = 1 / Math.sqrt(c * c + j * j + b * b);
    c *= m;
    j *= m;
    b *= m;
    k = h * b - i * j;
    i = i * c - f * b;
    f = f * j - h * c;
    if ((m = Math.sqrt(k * k + i * i + f * f))) {
        m = 1 / m;
        k *= m;
        i *= m;
        f *= m;
    } else f = i = k = 0;
    h = j * f - b * i;
    l = b * k - c * f;
    o = c * i - j * k;
    if ((m = Math.sqrt(h * h + l * l + o * o))) {
        m = 1 / m;
        h *= m;
        l *= m;
        o *= m;
    } else o = l = h = 0;
    d[0] = k;
    d[1] = h;
    d[2] = c;
    d[3] = 0;
    d[4] = i;
    d[5] = l;
    d[6] = j;
    d[7] = 0;
    d[8] = f;
    d[9] = o;
    d[10] = b;
    d[11] = 0;
    d[12] = -(k * e + i * g + f * a);
    d[13] = -(h * e + l * g + o * a);
    d[14] = -(c * e + j * g + b * a);
    d[15] = 1;
    return d;
};
mat4.str = function (a) {
    return (
        "[" +
        a[0] +
        ", " +
        a[1] +
        ", " +
        a[2] +
        ", " +
        a[3] +
        ", " +
        a[4] +
        ", " +
        a[5] +
        ", " +
        a[6] +
        ", " +
        a[7] +
        ", " +
        a[8] +
        ", " +
        a[9] +
        ", " +
        a[10] +
        ", " +
        a[11] +
        ", " +
        a[12] +
        ", " +
        a[13] +
        ", " +
        a[14] +
        ", " +
        a[15] +
        "]"
    );
};
var quat4 = {};
quat4.create = function (a) {
    var b = new glMatrixArrayType(4);
    if (a) {
        b[0] = a[0];
        b[1] = a[1];
        b[2] = a[2];
        b[3] = a[3];
    }
    return b;
};
quat4.set = function (a, b) {
    b[0] = a[0];
    b[1] = a[1];
    b[2] = a[2];
    b[3] = a[3];
    return b;
};
quat4.calculateW = function (a, b) {
    var c = a[0],
        d = a[1],
        e = a[2];
    if (!b || a == b) {
        a[3] = -Math.sqrt(Math.abs(1 - c * c - d * d - e * e));
        return a;
    }
    b[0] = c;
    b[1] = d;
    b[2] = e;
    b[3] = -Math.sqrt(Math.abs(1 - c * c - d * d - e * e));
    return b;
};
quat4.inverse = function (a, b) {
    if (!b || a == b) {
        a[0] *= 1;
        a[1] *= 1;
        a[2] *= 1;
        return a;
    }
    b[0] = -a[0];
    b[1] = -a[1];
    b[2] = -a[2];
    b[3] = a[3];
    return b;
};
quat4.length = function (a) {
    var b = a[0],
        c = a[1],
        d = a[2];
    a = a[3];
    return Math.sqrt(b * b + c * c + d * d + a * a);
};
quat4.normalize = function (a, b) {
    b || (b = a);
    var c = a[0],
        d = a[1],
        e = a[2],
        g = a[3],
        f = Math.sqrt(c * c + d * d + e * e + g * g);
    if (f == 0) {
        b[0] = 0;
        b[1] = 0;
        b[2] = 0;
        b[3] = 0;
        return b;
    }
    f = 1 / f;
    b[0] = c * f;
    b[1] = d * f;
    b[2] = e * f;
    b[3] = g * f;
    return b;
};
quat4.multiply = function (a, b, c) {
    c || (c = a);
    var d = a[0],
        e = a[1],
        g = a[2];
    a = a[3];
    var f = b[0],
        h = b[1],
        i = b[2];
    b = b[3];
    c[0] = d * b + a * f + e * i - g * h;
    c[1] = e * b + a * h + g * f - d * i;
    c[2] = g * b + a * i + d * h - e * f;
    c[3] = a * b - d * f - e * h - g * i;
    return c;
};
quat4.multiplyVec3 = function (a, b, c) {
    c || (c = b);
    var d = b[0],
        e = b[1],
        g = b[2];
    b = a[0];
    var f = a[1],
        h = a[2];
    a = a[3];
    var i = a * d + f * g - h * e,
        j = a * e + h * d - b * g,
        k = a * g + b * e - f * d;
    d = -b * d - f * e - h * g;
    c[0] = i * a + d * -b + j * -h - k * -f;
    c[1] = j * a + d * -f + k * -b - i * -h;
    c[2] = k * a + d * -h + i * -f - j * -b;
    return c;
};
quat4.toMat3 = function (a, b) {
    b || (b = mat3.create());
    var c = a[0],
        d = a[1],
        e = a[2],
        g = a[3],
        f = c + c,
        h = d + d,
        i = e + e,
        j = c * f,
        k = c * h;
    c = c * i;
    var l = d * h;
    d = d * i;
    e = e * i;
    f = g * f;
    h = g * h;
    g = g * i;
    b[0] = 1 - (l + e);
    b[1] = k - g;
    b[2] = c + h;
    b[3] = k + g;
    b[4] = 1 - (j + e);
    b[5] = d - f;
    b[6] = c - h;
    b[7] = d + f;
    b[8] = 1 - (j + l);
    return b;
};
quat4.toMat4 = function (a, b) {
    b || (b = mat4.create());
    var c = a[0],
        d = a[1],
        e = a[2],
        g = a[3],
        f = c + c,
        h = d + d,
        i = e + e,
        j = c * f,
        k = c * h;
    c = c * i;
    var l = d * h;
    d = d * i;
    e = e * i;
    f = g * f;
    h = g * h;
    g = g * i;
    b[0] = 1 - (l + e);
    b[1] = k - g;
    b[2] = c + h;
    b[3] = 0;
    b[4] = k + g;
    b[5] = 1 - (j + e);
    b[6] = d - f;
    b[7] = 0;
    b[8] = c - h;
    b[9] = d + f;
    b[10] = 1 - (j + l);
    b[11] = 0;
    b[12] = 0;
    b[13] = 0;
    b[14] = 0;
    b[15] = 1;
    return b;
};
quat4.slerp = function (a, b, c, d) {
    d || (d = a);
    var e = c;
    if (a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3] < 0) e = -1 * c;
    d[0] = 1 - c * a[0] + e * b[0];
    d[1] = 1 - c * a[1] + e * b[1];
    d[2] = 1 - c * a[2] + e * b[2];
    d[3] = 1 - c * a[3] + e * b[3];
    return d;
};
quat4.str = function (a) {
    return "[" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + "]";
};

// callbacks.js

// Autor: Léna PROUST & Tom BOIREAU (sur la base d'un code fourni par Nicolas COURILLEAU)

// =====================================================
// Mouse management
// =====================================================
var mouseDown = false;
var lastMouseX = null;
var lastMouseY = null;
var rotY = 0;
var rotX = -1;

var update_per_second = 60;
var wheel_sensivity = -0.001;

// =====================================================
window.requestAnimFrame = (function () {
    return (
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        function (
            /* function FrameRequestCallback */ callback,
            /* DOMElement Element */ element
        ) {
            window.setTimeout(callback, 1000 / update_per_second);
        }
    );
})();

// =====================================================
export function handleMouseWheel(event) {
    distCENTER[2] += event.deltaY * wheel_sensivity;
}

// =====================================================
export function handleMouseDown(event) {
    mouseDown = true;
    lastMouseX = event.clientX;
    lastMouseY = event.clientY;
}

// =====================================================
export function handleMouseUp(event) {
    mouseDown = false;
}

// =====================================================
export function handleMouseMove(event) {
    if (!mouseDown) return;

    var newX = event.clientX;
    var newY = event.clientY;
    var deltaX = newX - lastMouseX;
    var deltaY = newY - lastMouseY;

    if (event.shiftKey) {
        distCENTER[2] += deltaY / 100.0;
    } else {
        rotY += degToRad(deltaX / 5);
        rotX += degToRad(deltaY / 5);

        var maxRotX = degToRad(55);
        var minRotX = degToRad(-80);

        rotX = Math.max(minRotX, Math.min(maxRotX, rotX));

        mat4.identity(rotMatrix);
        mat4.rotate(rotMatrix, rotX, [1, 0, 0]);
        mat4.rotate(rotMatrix, rotY, [0, 0, 1]);
    }

    lastMouseX = newX;
    lastMouseY = newY;
}

// =====================================================
// FONCTIONS DE CONVERSION
// =====================================================

// =====================================================
export function degToRad(degrees) {
    return (degrees * Math.PI) / 180;
}

// =====================================================
export function radToDeg(radians) {
    return (radians * 180) / Math.PI;
}

// =====================================================
export function rgbToHex(r, g, b) {
    r = Math.floor(r * 255);
    g = Math.floor(g * 255);
    b = Math.floor(b * 255);
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

export function hexToRgb(hex) {
    hex = hex.replace("#", "");
    return [
        parseInt(hex.substring(0, 2), 16) / 255,
        parseInt(hex.substring(2, 4), 16) / 255,
        parseInt(hex.substring(4, 6), 16) / 255,
    ];
}

export function invertColor(rgb) {
    return rgb.map((c) => 1 - c);
}

export function rgbToLab(r, g, b) {
    // Helper function to convert RGB to XYZ
    function rgbToXyz(r, g, b) {
        r = r / 255;
        g = g / 255;
        b = b / 255;

        r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
        g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
        b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;

        r = r * 100;
        g = g * 100;
        b = b * 100;

        // Observer. = 2°, Illuminant = D65
        const x = r * 0.4124 + g * 0.3576 + b * 0.1805;
        const y = r * 0.2126 + g * 0.7152 + b * 0.0722;
        const z = r * 0.0193 + g * 0.1192 + b * 0.9505;

        return [x, y, z];
    }

    // Helper function to convert XYZ to LAB
    function xyzToLab(x, y, z) {
        const refX = 95.047;
        const refY = 100.0;
        const refZ = 108.883;

        x = x / refX;
        y = y / refY;
        z = z / refZ;

        x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
        y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
        z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;

        const l = 116 * y - 16;
        const a = 500 * (x - y);
        const b = 200 * (y - z);

        return [l, a, b];
    }

    const [x, y, z] = rgbToXyz(r, g, b);
    return xyzToLab(x, y, z);
}

// =====================================================
// UPDATE
// =====================================================

// ==========================================
function tick() {
    if (runAnimation) {
        requestAnimFrame(tick);
    }
    drawScene();
}

// selector.js

// Author : Léna PROUST & Tom BOIREAU

// Ce fichier gère la sélection d'objets 3D, et permet de modifier leurs paramètres (position, rotation, couleur)

var sceneObjects = [];
var selectedObject = null;

const DEF_POSITION = vec3.create([0, 0, 0]);
const DEF_ROTATION = vec3.create([0, 0, 0]);
const DEF_COLOR = vec3.create([1, 1, 1]);

var selectorElem = null;
var posXElem = null;
var posYElem = null;
var posZElem = null;
var rotXElem = null;
var rotYElem = null;
var rotZElem = null;
var colorElem = null;
var wireframeElem = null;
var textureElem = null;
var normalElem = null;
var amplElem = null;
var resolutionElem = null;

// =====================================================
// FONCTIONS GENERALES, INITIALISATIONS
// =====================================================

// =====================================================
function initSelector() {
    // Initialisation des éléments HTML
    selectorElem = document.getElementById("object-selector");
    posXElem = document.getElementById("posX");
    posYElem = document.getElementById("posY");
    posZElem = document.getElementById("posZ");
    rotXElem = document.getElementById("rotX");
    rotYElem = document.getElementById("rotY");
    rotZElem = document.getElementById("rotZ");
    colorElem = document.getElementById("color");
    wireframeElem = document.getElementById("wireframe");
    textureElem = document.getElementById("texture");
    normalElem = document.getElementById("normal");
    amplElem = document.getElementById("amplitude");
    resolutionElem = document.getElementById("resolution");

    // Charger le système de heightmap
    initHeightmap();

    // Charger le système de colorsRamp
    initColors();

    // Ajout des objets de la scène
    addObj("Plane", new plane());
    const obj = addMeshObj("porsche.obj");

    //handleGeneratePerlin();
    //addHeightmapObj();
}

// =====================================================
function drawScene() {
    if (!(gl && runAnimation)) return;

    gl.clear(gl.COLOR_BUFFER_BIT);

    for (var i = 0; i < sceneObjects.length; i++) {
        sceneObjects[i].draw();
    }
}

// =====================================================
// FONCTIONS DE SELECTION
// =====================================================

// =====================================================
export function deselectAll() {
    for (var i = 0; i < sceneObjects.length; i++) {
        sceneObjects[i].option.selected = false;
    }
}

// =====================================================
export function select(obj) {
    // Désélection de tous les objets
    deselectAll();

    // Sélection de l'objet
    selectedObject = obj;
    obj.option.selected = true;

    // Mise à jour des champs de l'interface
    posXElem.value = obj.position[0];
    posYElem.value = obj.position[1];
    posZElem.value = obj.position[2];
    rotXElem.value = radToDeg(obj.rotation[0]);
    rotYElem.value = radToDeg(obj.rotation[1]);
    rotZElem.value = radToDeg(obj.rotation[2]);

    if (obj.color) {
        colorElem.value = rgbToHex(obj.color[0], obj.color[1], obj.color[2]);
        colorElem.disabled = false;
    } else {
        colorElem.value = "#FFFFFF";
        colorElem.disabled = true;
    }

    try {
        wireframeElem.checked = obj.getWireState();
        wireframeElem.disabled = false;
    } catch (e) {
        wireframeElem.checked = false;
        wireframeElem.disabled = true;
    }

    try {
        textureElem.checked = obj.getTextureState();
        textureElem.disabled = false;
    } catch (e) {
        textureElem.checked = false;
        textureElem.disabled = true;
    }

    try {
        normalElem.checked = obj.getNormalState();
        normalElem.disabled = false;
    } catch (e) {
        normalElem.checked = false;
        normalElem.disabled = true;
    }

    try {
        amplElem.value = obj.getAmplitude();
        amplElem.disabled = false;
    } catch (e) {
        amplElem.value = 1;
        amplElem.disabled = true;
    }

    try {
        resolutionElem.value = obj.getResolution();
        resolutionElem.disabled = false;
    } catch (e) {
        resolutionElem.value = 512.0;
        resolutionElem.disabled = true;
    }
}

// =====================================================
export function addObj(objName, obj) {
    sceneObjects.push(obj);

    var option = document.createElement("option");
    option.text = objName;

    selectorElem.add(option);
    obj.option = option;

    select(obj);

    return obj;
}

// =====================================================
export function addMeshObj(objName) {
    const obj = new objmesh(objName, DEF_POSITION, DEF_ROTATION, DEF_COLOR);

    return addObj(objName, obj);
}

// =====================================================
export function addHeightmapObj(objName = "Heightmap") {
    const obj = new map3D(
        getHeightmap(),
        DEF_POSITION,
        DEF_ROTATION,
        DEF_COLOR
    );

    return addObj(objName, obj);
}

// =====================================================
export function addBoundingBox(objName = "BoundingBox") {
    const obj = new BoundingBox(DEF_POSITION, DEF_ROTATION, DEF_COLOR);

    return addObj(objName, obj);
}

// =====================================================
export function addVolumeBox(url, sizex, sizey, sizez, objName = "VolumeBox") {
    const obj = new VolumeBox(
        [url, sizex, sizey, sizez],
        DEF_POSITION,
        DEF_ROTATION,
        DEF_COLOR
    );

    return addObj(objName, obj);
}

// =====================================================
export function deleteSelected() {
    var index = sceneObjects.indexOf(selectedObject);
    if (index > -1) {
        sceneObjects.splice(index, 1);
        selectorElem.remove(selectedObject.option.index);
    }
}

// =====================================================
export function changeObject() {
    var index = selectorElem.selectedIndex;
    select(sceneObjects[index]);
}

// =====================================================
export function changePosition() {
    var posX = posXElem.value;
    var posY = posYElem.value;
    var posZ = posZElem.value;

    const POSITION = vec3.create([posX, posY, posZ]);

    selectedObject.setPosition(POSITION);
}

// =====================================================
export function changeRotation() {
    var rotX = rotXElem.value;
    var rotY = rotYElem.value;
    var rotZ = rotZElem.value;

    rotX = degToRad(rotX);
    rotY = degToRad(rotY);
    rotZ = degToRad(rotZ);

    const ROTATION = vec3.create([rotX, rotY, rotZ]);

    selectedObject.setRotation(ROTATION);
}

// =====================================================
export function changeColor() {
    var col = colorElem.value;
    var colR = parseInt(col.substring(1, 3), 16) / 255;
    var colG = parseInt(col.substring(3, 5), 16) / 255;
    var colB = parseInt(col.substring(5, 7), 16) / 255;

    const COLOR = vec3.create([colR, colG, colB]);

    selectedObject.setColor(COLOR);
}

// =====================================================
export function changeResolution() {
    try {
        var resValue = parseFloat(resolutionElem.value);
        selectedObject.setResolution(resValue);
    } catch (e) {
        resolutionElem.disabled = true;
    }
}

// =====================================================
export function changeWireframe() {
    try {
        selectedObject.switchWireState();
        wireframeElem.checked = selectedObject.getWireState();
    } catch (e) {
        wireframeElem.checked = false;
    }
}

// =====================================================
export function changeTexture() {
    try {
        selectedObject.switchTextureState();
        textureElem.checked = selectedObject.getTextureState();
    } catch (e) {
        textureElem.checked = false;
    }
}

// =====================================================
export function changeNormal() {
    try {
        selectedObject.switchNormalState();
        normalElem.checked = selectedObject.getNormalState();
    } catch (e) {
        normalElem.checked = false;
    }
}

// =====================================================
export function changeAmplitude() {
    try {
        var amplValue = parseFloat(amplElem.value);
        selectedObject.setAmplitude(amplValue);
    } catch (e) {
        amplElem.disabled = true;
    }
}

// renderer.js

// Autor: Léna PROUST & Tom BOIREAU (sur la base d'un code fourni par Nicolas COURILLEAU)

// =====================================================
var gl;
var canvas;

// =====================================================
var mvMatrix = mat4.create();
var pMatrix = mat4.create();
var rotMatrix = mat4.create();
var distCENTER;

// =====================================================
// FONCTIONS GENERALES, INITIALISATIONS
// =====================================================

// =====================================================
function initGL(canvas) {
    try {
        gl = canvas.getContext("webgl2");
        gl.viewportWidth = canvas.width;
        gl.viewportHeight = canvas.height;
        gl.viewport(0, 0, canvas.width, canvas.height);

        gl.clearColor(0.78, 0.89, 0.91, 1.0);
        gl.enable(gl.DEPTH_TEST);
        gl.enable(gl.CULL_FACE);
        gl.cullFace(gl.BACK);
    } catch (e) {}
    if (!gl) {
        console.log("Could not initialise WebGL");
    }
}

// =====================================================
export function webGLStart(c) {
    canvas = c;

    initOBJ(window, document);

    runAnimation = true;

    canvas.onmousedown = handleMouseDown;
    document.onmouseup = handleMouseUp;
    document.onmousemove = handleMouseMove;
    canvas.onwheel = handleMouseWheel;

    initGL(canvas);

    mat4.perspective(
        45,
        gl.viewportWidth / gl.viewportHeight,
        0.1,
        100.0,
        pMatrix
    );
    mat4.identity(rotMatrix);
    mat4.rotate(rotMatrix, rotX, [1, 0, 0]);
    mat4.rotate(rotMatrix, rotY, [0, 0, 1]);

    distCENTER = vec3.create([0, 0, -3]);

    initSelector();

    tick();
}

// objLoader.js
var OBJ = {};

function initOBJ(window, document, undefined) {
    "use strict";
    // Thanks to CMS for the startsWith function
    // http://stackoverflow.com/questions/646628/javascript-startswith/646643#646643
    if (typeof String.prototype.startsWith !== "function") {
        String.prototype.startsWith = function (str) {
            return this.slice(0, str.length) === str;
        };
    }

    /**
     * The main Mesh class. The constructor will parse through the OBJ file data
     * and collect the vertex, vertex normal, texture, and face information. This
     * information can then be used later on when creating your VBOs. See
     * OBJ.initMeshBuffers for an example of how to use the newly created Mesh
     *
     * @class Mesh
     * @constructor
     *
     * @param {String} objectData a string representation of an OBJ file with newlines preserved.
     */
    OBJ.Mesh = function (objectData) {
        /*
     The OBJ file format does a sort of compression when saving a model in a
     program like Blender. There are at least 3 sections (4 including textures)
     within the file. Each line in a section begins with the same string:
       * 'v': indicates vertex section
       * 'vn': indicates vertex normal section
       * 'f': indicates the faces section
       * 'vt': indicates vertex texture section (if textures were used on the model)
     Each of the above sections (except for the faces section) is a list/set of
     unique vertices.

     Each line of the faces section contains a list of
     (vertex, [texture], normal) groups
     Some examples:
         // the texture index is optional, both formats are possible for models
         // without a texture applied
         f 1/25 18/46 12/31
         f 1//25 18//46 12//31

         // A 3 vertex face with texture indices
         f 16/92/11 14/101/22 1/69/1

         // A 4 vertex face
         f 16/92/11 40/109/40 38/114/38 14/101/22

     The first two lines are examples of a 3 vertex face without a texture applied.
     The second is an example of a 3 vertex face with a texture applied.
     The third is an example of a 4 vertex face. Note: a face can contain N
     number of vertices.

     Each number that appears in one of the groups is a 1-based index
     corresponding to an item from the other sections (meaning that indexing
     starts at one and *not* zero).

     For example:
         `f 16/92/11` is saying to
           - take the 16th element from the [v] vertex array
           - take the 92nd element from the [vt] texture array
           - take the 11th element from the [vn] normal array
         and together they make a unique Vertex.
     Using all 3+ unique Vertices from the face line will produce a polygon.

     Now, you could just go through the OBJ file and create a new Vertex for
     each face line and WebGL will draw what appears to be the same model.
     However, vertices will be overlapped and duplicated all over the place.

     Consider a cube in 3D space centered about the origin and each side is
     2 units long. The front face (with the positive Z-axis pointing towards
     you) would have a Top Right vertex (looking orthogonal to its normal)
     mapped at (1,1,1) The right face would have a Top Left vertex (looking
     orthogonal to its normal) at (1,1,1) and the top face would have a Bottom
     Right vertex (looking orthogonal to its normal) at (1,1,1). Each face
     has a vertex at the same coordinates, however, three distinct vertices
     will be drawn at the same spot.

     To solve the issue of duplicate Vertices (the `(vertex, [texture], normal)`
     groups), while iterating through the face lines, when a group is encountered
     the whole group string ('16/92/11') is checked to see if it exists in the
     packed.hashindices object, and if it doesn't, the indices it specifies
     are used to look up each attribute in the corresponding attribute arrays
     already created. The values are then copied to the corresponding unpacked
     array (flattened to play nice with WebGL's ELEMENT_ARRAY_BUFFER indexing),
     the group string is added to the hashindices set and the current unpacked
     index is used as this hashindices value so that the group of elements can
     be reused. The unpacked index is incremented. If the group string already
     exists in the hashindices object, its corresponding value is the index of
     that group and is appended to the unpacked indices array.
     */
        var verts = [],
            vertNormals = [],
            textures = [],
            unpacked = {};
        // unpacking stuff
        unpacked.verts = [];
        unpacked.norms = [];
        unpacked.textures = [];
        unpacked.hashindices = {};
        unpacked.indices = [];
        unpacked.index = 0;
        // array of lines separated by the newline
        var lines = objectData.split("\n"),
            i;
        for (i = 0; i < lines.length; i++) {
            // if this is a vertex
            var line;
            if (lines[i].trim().startsWith("v ")) {
                line = lines[i].trim().split(/\s+/);
                line.shift();
                verts.push(line[0]);
                verts.push(line[1]);
                verts.push(line[2]);
            } else if (lines[i].trim().startsWith("vn")) {
                // if this is a vertex normal
                line = lines[i].trim().split(/\s+/);
                line.shift();
                vertNormals.push(line[0]);
                vertNormals.push(line[1]);
                vertNormals.push(line[2]);
            } else if (lines[i].trim().startsWith("vt")) {
                // if this is a texture
                line = lines[i].trim().split(/\s+/);
                line.shift();
                textures.push(line[0]);
                textures.push(line[1]);
            } else if (lines[i].trim().startsWith("f ")) {
                // if this is a face
                /*
        split this face into an array of Vertex groups
        for example:
           f 16/92/11 14/101/22 1/69/1
        becomes:
          ['16/92/11', '14/101/22', '1/69/1'];
        */
                line = lines[i].trim().split(/\s+/);
                line.shift();
                var quad = false;
                for (var j = 0; j < line.length; j++) {
                    // Triangulating quads
                    // quad: 'f v0/t0/vn0 v1/t1/vn1 v2/t2/vn2 v3/t3/vn3/'
                    // corresponding triangles:
                    //      'f v0/t0/vn0 v1/t1/vn1 v2/t2/vn2'
                    //      'f v2/t2/vn2 v3/t3/vn3 v0/t0/vn0'
                    if (j === 3 && !quad) {
                        // add v2/t2/vn2 in again before continuing to 3
                        j = 2;
                        quad = true;
                    }
                    if (line[j] in unpacked.hashindices) {
                        unpacked.indices.push(unpacked.hashindices[line[j]]);
                    } else {
                        /*
                Each element of the face line array is a Vertex which has its
                attributes delimited by a forward slash. This will separate
                each attribute into another array:
                    '19/92/11'
                becomes:
                    Vertex = ['19', '92', '11'];
                where
                    Vertex[0] is the vertex index
                    Vertex[1] is the texture index
                    Vertex[2] is the normal index
                 Think of faces having Vertices which are comprised of the
                 attributes location (v), texture (vt), and normal (vn).
                 */
                        var Vertex = line[j].split("/");
                        /*
                 The verts, textures, and vertNormals arrays each contain a
                 flattend array of coordinates.

                 Because it gets confusing by referring to Vertex and then
                 vertex (both are different in my descriptions) I will explain
                 what's going on using the vertexNormals array:

                 Vertex[2] will contain the one-based index of the vertexNormals
                 section (vn). One is subtracted from this index number to play
                 nice with javascript's zero-based array indexing.

                 Because vertexNormal is a flattened array of x, y, z values,
                 simple pointer arithmetic is used to skip to the start of the
                 vertexNormal, then the offset is added to get the correct
                 component: +0 is x, +1 is y, +2 is z.

                 This same process is repeated for verts and textures.
                 */
                        // vertex position
                        unpacked.verts.push(verts[(Vertex[0] - 1) * 3 + 0]);
                        unpacked.verts.push(verts[(Vertex[0] - 1) * 3 + 1]);
                        unpacked.verts.push(verts[(Vertex[0] - 1) * 3 + 2]);
                        // vertex textures
                        unpacked.textures.push(
                            textures[(Vertex[1] - 1) * 2 + 0]
                        );
                        unpacked.textures.push(
                            textures[(Vertex[1] - 1) * 2 + 1]
                        );
                        // vertex normals
                        unpacked.norms.push(
                            vertNormals[(Vertex[2] - 1) * 3 + 0]
                        );
                        unpacked.norms.push(
                            vertNormals[(Vertex[2] - 1) * 3 + 1]
                        );
                        unpacked.norms.push(
                            vertNormals[(Vertex[2] - 1) * 3 + 2]
                        );
                        // add the newly created vertex to the list of indices
                        unpacked.hashindices[line[j]] = unpacked.index;
                        unpacked.indices.push(unpacked.index);
                        // increment the counter
                        unpacked.index += 1;
                    }
                    if (j === 3 && quad) {
                        // add v0/t0/vn0 onto the second triangle
                        unpacked.indices.push(unpacked.hashindices[line[0]]);
                    }
                }
            }
        }
        this.vertices = unpacked.verts;
        this.vertexNormals = unpacked.norms;
        this.textures = unpacked.textures;
        this.indices = unpacked.indices;
    };

    var Ajax = function () {
        // this is just a helper class to ease ajax calls
        var _this = this;
        this.xmlhttp = new XMLHttpRequest();

        this.get = function (url, callback) {
            _this.xmlhttp.onreadystatechange = function () {
                if (_this.xmlhttp.readyState === 4) {
                    callback(_this.xmlhttp.responseText, _this.xmlhttp.status);
                }
            };
            _this.xmlhttp.open("GET", url, true);
            _this.xmlhttp.send();
        };
    };

    /**
     * Takes in an object of `mesh_name`, `'/url/to/OBJ/file'` pairs and a callback
     * function. Each OBJ file will be ajaxed in and automatically converted to
     * an OBJ.Mesh. When all files have successfully downloaded the callback
     * function provided will be called and passed in an object containing
     * the newly created meshes.
     *
     * **Note:** In order to use this function as a way to download meshes, a
     * webserver of some sort must be used.
     *
     * @param {Object} nameAndURLs an object where the key is the name of the mesh and the value is the url to that mesh's OBJ file
     *
     * @param {Function} completionCallback should contain a function that will take one parameter: an object array where the keys will be the unique object name and the value will be a Mesh object
     *
     * @param {Object} meshes In case other meshes are loaded separately or if a previously declared variable is desired to be used, pass in a (possibly empty) json object of the pattern: { '<mesh_name>': OBJ.Mesh }
     *
     */
    OBJ.downloadMeshes = function (nameAndURLs, completionCallback, meshes) {
        // the total number of meshes. this is used to implement "blocking"
        var semaphore = Object.keys(nameAndURLs).length;
        // if error is true, an alert will given
        var error = false;
        // this is used to check if all meshes have been downloaded
        // if meshes is supplied, then it will be populated, otherwise
        // a new object is created. this will be passed into the completionCallback
        if (meshes === undefined) meshes = {};
        // loop over the mesh_name,url key,value pairs
        for (var mesh_name in nameAndURLs) {
            if (nameAndURLs.hasOwnProperty(mesh_name)) {
                new Ajax().get(
                    nameAndURLs[mesh_name],
                    (function (name) {
                        return function (data, status) {
                            if (status === 200) {
                                meshes[name] = new OBJ.Mesh(data);
                            } else {
                                error = true;
                                console.error(
                                    'An error has occurred and the mesh "' +
                                        name +
                                        '" could not be downloaded.'
                                );
                            }
                            // the request has finished, decrement the counter
                            semaphore--;
                            if (semaphore === 0) {
                                if (error) {
                                    // if an error has occurred, the user is notified here and the
                                    // callback is not called
                                    console.error(
                                        "An error has occurred and one or meshes has not been " +
                                            "downloaded. The execution of the script has terminated."
                                    );
                                    throw "";
                                }
                                // there haven't been any errors in retrieving the meshes
                                // call the callback
                                completionCallback(meshes);
                            }
                        };
                    })(mesh_name)
                );
            }
        }
    };

    /**
     * Takes in the WebGL context and a Mesh, then creates and appends the buffers
     * to the mesh object as attributes.
     *
     * @param {WebGLRenderingContext} gl the `canvas.getContext('webgl')` context instance
     * @param {Mesh} mesh a single `OBJ.Mesh` instance
     *
     * The newly created mesh attributes are:
     *
     * Attrbute | Description
     * :--- | ---
     * **normalBuffer**       |contains the model&#39;s Vertex Normals
     * normalBuffer.itemSize  |set to 3 items
     * normalBuffer.numItems  |the total number of vertex normals
     * |
     * **textureBuffer**      |contains the model&#39;s Texture Coordinates
     * textureBuffer.itemSize |set to 2 items
     * textureBuffer.numItems |the number of texture coordinates
     * |
     * **vertexBuffer**       |contains the model&#39;s Vertex Position Coordinates (does not include w)
     * vertexBuffer.itemSize  |set to 3 items
     * vertexBuffer.numItems  |the total number of vertices
     * |
     * **indexBuffer**        |contains the indices of the faces
     * indexBuffer.itemSize   |is set to 1
     * indexBuffer.numItems   |the total number of indices
     *
     * A simple example (a lot of steps are missing, so don't copy and paste):
     *
     *     var gl   = canvas.getContext('webgl'),
     *         mesh = OBJ.Mesh(obj_file_data);
     *     // compile the shaders and create a shader program
     *     var shaderProgram = gl.createProgram();
     *     // compilation stuff here
     *     ...
     *     // make sure you have vertex, vertex normal, and texture coordinate
     *     // attributes located in your shaders and attach them to the shader program
     *     shaderProgram.vertexPositionAttribute = gl.getAttribLocation(shaderProgram, "aVertexPosition");
     *     gl.enableVertexAttribArray(shaderProgram.vertexPositionAttribute);
     *
     *     shaderProgram.vertexNormalAttribute = gl.getAttribLocation(shaderProgram, "aVertexNormal");
     *     gl.enableVertexAttribArray(shaderProgram.vertexNormalAttribute);
     *
     *     shaderProgram.textureCoordAttribute = gl.getAttribLocation(shaderProgram, "aTextureCoord");
     *     gl.enableVertexAttribArray(shaderProgram.textureCoordAttribute);
     *
     *     // create and initialize the vertex, vertex normal, and texture coordinate buffers
     *     // and save on to the mesh object
     *     OBJ.initMeshBuffers(gl, mesh);
     *
     *     // now to render the mesh
     *     gl.bindBuffer(gl.ARRAY_BUFFER, mesh.vertexBuffer);
     *     gl.vertexAttribPointer(shaderProgram.vertexPositionAttribute, mesh.vertexBuffer.itemSize, gl.FLOAT, false, 0, 0);
     *
     *     gl.bindBuffer(gl.ARRAY_BUFFER, mesh.textureBuffer);
     *     gl.vertexAttribPointer(shaderProgram.textureCoordAttribute, mesh.textureBuffer.itemSize, gl.FLOAT, false, 0, 0);
     *
     *     gl.bindBuffer(gl.ARRAY_BUFFER, mesh.normalBuffer);
     *     gl.vertexAttribPointer(shaderProgram.vertexNormalAttribute, mesh.normalBuffer.itemSize, gl.FLOAT, false, 0, 0);
     *
     *     gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, model.mesh.indexBuffer);
     *     gl.drawElements(gl.TRIANGLES, model.mesh.indexBuffer.numItems, gl.UNSIGNED_SHORT, 0);
     */
    OBJ.initMeshBuffers = function (gl, mesh) {
        mesh.vertexBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, mesh.vertexBuffer);
        gl.bufferData(
            gl.ARRAY_BUFFER,
            new Float32Array(mesh.vertices),
            gl.STATIC_DRAW
        );
        mesh.vertexBuffer.itemSize = 3;
        mesh.vertexBuffer.numItems = mesh.vertices.length / 3;

        mesh.normalBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, mesh.normalBuffer);
        gl.bufferData(
            gl.ARRAY_BUFFER,
            new Float32Array(mesh.vertexNormals),
            gl.STATIC_DRAW
        );
        mesh.normalBuffer.itemSize = 3;
        mesh.normalBuffer.numItems = mesh.vertexNormals.length / 3;

        mesh.textureBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, mesh.textureBuffer);
        gl.bufferData(
            gl.ARRAY_BUFFER,
            new Float32Array(mesh.textures),
            gl.STATIC_DRAW
        );
        mesh.textureBuffer.itemSize = 2;
        mesh.textureBuffer.numItems = mesh.textures.length / 2;

        mesh.indexBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, mesh.indexBuffer);
        gl.bufferData(
            gl.ELEMENT_ARRAY_BUFFER,
            new Uint32Array(mesh.indices),
            gl.STATIC_DRAW
        );
        mesh.indexBuffer.itemSize = 1;
        mesh.indexBuffer.numItems = mesh.indices.length;
    };
}

// colors.js

var cr_min_threshold = null;
var cr_max_threshold = null;

var cr_body = null;
var cr_in_color = null;
var cr_in_threshold = null;

let colors = [
    [0.0, [0.78, 0.89, 0.91, 1.0]],
    [1.0, [1.0, 1.0, 1.0, 1.0]],
];

function initColors() {
    cr_min_threshold = document.getElementById("cr_min_threshold");
    cr_max_threshold = document.getElementById("cr_max_threshold");
    cr_body = document.getElementById("colors-ramp-body");
    cr_in_color = document.getElementById("cr-color-add");
    cr_in_threshold = document.getElementById("cr-threshold-add");

    document.getElementById("cr-color-max").onchange = () => crChangeColor(1.0);
    document.getElementById("cr-color-min").onchange = () => crChangeColor(0.0);

    crChangeColor(1.0);
    crChangeColor(0.0);
}

function colorRamp(t) {
    // Fonction pour effectuer l'interpolation linéaire (mix)
    function mix(a, b, t) {
        return a.map((val, i) => val * (1 - t) + b[i] * t);
    }

    // Trouver les deux couleurs entre lesquelles interpoler
    for (let i = 0; i < colors.length - 1; i++) {
        if (t >= colors[i][0] && t <= colors[i + 1][0]) {
            let tNorm = (t - colors[i][0]) / (colors[i + 1][0] - colors[i][0]);
            return mix(colors[i][1], colors[i + 1][1], tNorm);
        }
    }

    // Si t est en dehors de l'intervalle, retourner la couleur la plus proche
    if (t < colors[0][0]) {
        return colors[0][1];
    } else {
        return colors[colors.length - 1][1];
    }
}

function getColorRamp(size = 256, channel = 4) {
    let arrayData = new Float32Array(size * channel); // Créer un tableau de la taille adéquate
    for (let i = 0; i < size; i++) {
        const baseIndex = i * channel;

        // Interpolation linéaire entre col1 et col2 pour chaque canal
        let col = colorRamp(i / 255.0);
        arrayData[baseIndex] = col[0];
        arrayData[baseIndex + 1] = col[1];
        arrayData[baseIndex + 2] = col[2];
        arrayData[baseIndex + 3] = col[3];
    }
    return arrayData;
}

function getColorThreshMin() {
    return cr_min_threshold.value;
}

function getColorThreshMax() {
    return cr_max_threshold.value;
}

function addColor(index, color, threshold) {
    let tr = document.createElement("tr");

    let tdColor = document.createElement("td");
    let inputColor = document.createElement("input");
    inputColor.type = "color";
    inputColor.value = color;
    inputColor.onchange = () => crChangeColor(threshold);
    tdColor.appendChild(inputColor);

    let tdThreshold = document.createElement("td");
    let inputThreshold = document.createElement("input");
    inputThreshold.type = "range";
    inputThreshold.min = "0.00392157";
    inputThreshold.max = "0.99607843";
    inputThreshold.step = "0.00392157";
    inputThreshold.value = threshold;
    inputThreshold.disabled = true;
    tdThreshold.appendChild(inputThreshold);

    let tdButton = document.createElement("td");
    let button = document.createElement("button");
    button.textContent = "Delete";
    button.onclick = () => removeColor(threshold);
    tdButton.appendChild(button);

    tr.appendChild(tdColor);
    tr.appendChild(tdThreshold);
    tr.appendChild(tdButton);

    cr_body.insertBefore(tr, cr_body.children[index]);
}

function getIndexFromThreshold(threshold) {
    let index = -1;
    for (let i = 0; i < colors.length; i++) {
        if (index == -1 || colors[i][0] < threshold) {
            index = i;
        }
    }
    return index;
}

function removeColor(threshold) {
    let index = getIndexFromThreshold(threshold) + 1;
    let tr = cr_body.children[index];
    tr.remove();
    colors.splice(index, 1);
}

function crChangeColor(threshold) {
    let index = threshold == 0 ? 0 : getIndexFromThreshold(threshold) + 1;
    let color = cr_body.children[index].children[0].children[0].value;
    colors[index][1] = invertColor(hexToRgb(color));
}

export function addColorToRamp() {
    let thresh = parseFloat(cr_in_threshold.value);
    let index = getIndexFromThreshold(thresh);
    let colorRGB = hexToRgb(cr_in_color.value);
    colors.splice(index + 1, 0, [thresh, invertColor(colorRGB)]);
    addColor(index + 1, cr_in_color.value, thresh);
}

// 3DObjects.js

// Autor: Léna PROUST & Tom BOIREAU (sur la base d'un code fourni par Nicolas COURILLEAU)

var shadersFolder = "shaders/";
var objFolder = "objects/";

// =====================================================
// FONCTIONS ASYNCHRONES (Merci Javascript de ne pas les permettre dans les classes)
// =====================================================

import sh_box_vs from "url:./shaders/box.vs";
import sh_box_fs from "url:./shaders/box.fs";
import sh_heightmaps_vs from "url:./shaders/heightmaps.vs";
import sh_heightmaps_fs from "url:./shaders/heightmaps.fs";
import sh_obj_vs from "url:./shaders/obj.vs";
import sh_obj_fs from "url:./shaders/obj.fs";
import sh_plane_vs from "url:./shaders/plane.vs";
import sh_plane_fs from "url:./shaders/plane.fs";
import sh_volume_vs from "url:./shaders/volume.vs";
import sh_volume_fs from "url:./shaders/volume.fs";
import sh_wire_vs from "url:./shaders/wire.vs";
import sh_wire_fs from "url:./shaders/wire.fs";

const SHADERS = {
    box: {
        vs: sh_box_vs,
        fs: sh_box_fs,
    },
    heightmaps: {
        vs: sh_heightmaps_vs,
        fs: sh_heightmaps_fs,
    },
    obj: {
        vs: sh_obj_vs,
        fs: sh_obj_fs,
    },
    plane: {
        vs: sh_plane_vs,
        fs: sh_plane_fs,
    },
    volume: {
        vs: sh_volume_vs,
        fs: sh_volume_fs,
    },
    wire: {
        vs: sh_wire_vs,
        fs: sh_wire_fs,
    },
};

// =====================================================

import bunny_obj from "url:./objects/bunny.obj";
import mustang_obj from "url:./objects/mustang.obj";
import porsche_obj from "url:./objects/porsche.obj";
import sphere_obj from "url:./objects/sphere.obj";

const OBJECTS = {
    "bunny.obj": {
        url: bunny_obj,
    },
    "mustang.obj": {
        url: mustang_obj,
    },
    "porsche.obj": {
        url: porsche_obj,
    },
    "sphere.obj": {
        url: sphere_obj,
    },
};

import text_floor from "url:./textures/floor.jpg";
import text_height_color from "url:./textures/height_color.png";
import text_obj_texture from "url:./textures/obj_texture.png";
import norm_surface from "url:./normalmaps/Surface10.png";
import norm_water from "url:./normalmaps/water.jpg";

function loadObjFile(Obj3D) {
    const url = OBJECTS[Obj3D.objFname].url;

    var xhttp = new XMLHttpRequest();

    xhttp.onreadystatechange = function () {
        if (xhttp.readyState == 4 && xhttp.status == 200) {
            var tmpMesh = new OBJ.Mesh(xhttp.responseText);
            OBJ.initMeshBuffers(gl, tmpMesh);
            Obj3D.mesh = tmpMesh;
            try {
                Obj3D.endLoad();
            } catch (e) {}
        }
    };

    xhttp.open("GET", url, true);
    xhttp.send();
}

// =====================================================
// =====================================================
function loadShaders(Obj3D, shaderName = null) {
    if (shaderName == null) shaderName = Obj3D.shaderName;
    loadShaderText(Obj3D, SHADERS[shaderName].vs || null, ".vs");
    loadShaderText(Obj3D, SHADERS[shaderName].fs || null, ".fs");
}

// =====================================================
function loadShaderText(Obj3D, url, ext) {
    // lecture asynchrone...
    var xhttp = new XMLHttpRequest();

    xhttp.onreadystatechange = function () {
        if (xhttp.readyState == 4 && xhttp.status == 200) {
            if (ext == ".vs") {
                Obj3D.vsTxt = xhttp.responseText;
                Obj3D.loaded++;
            }
            if (ext == ".fs") {
                Obj3D.fsTxt = xhttp.responseText;
                Obj3D.loaded++;
            }
            if (Obj3D.loaded == 2) {
                Obj3D.loaded++;
                compileShaders(Obj3D);
                Obj3D.loaded++;
            }
        }
    };

    Obj3D.loaded = 0;
    xhttp.open("GET", url, true);
    xhttp.send();
}
// =====================================================
function downloadImageFromUint8Array(
    data,
    width,
    height,
    channels = 4,
    filename = "image.png"
) {
    // Vérification des dimensions
    if (data.length !== width * height * channels) {
        throw new Error(
            "La taille du tableau Uint8Array ne correspond pas aux dimensions spécifiées."
        );
    }

    // Création d'un canvas
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");

    // Création d'une image Data
    const imageData = ctx.createImageData(width, height);

    // Copie des données
    for (let i = 0; i < data.length; i++) {
        imageData.data[i] = data[i];
    }

    // Dessiner les données sur le canvas
    ctx.putImageData(imageData, 0, 0);

    // Convertir le canvas en URL de données
    canvas.toBlob((blob) => {
        // Créer un lien pour télécharger l'image
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;

        // Simuler un clic pour déclencher le téléchargement
        link.click();

        // Nettoyer l'URL de blob
        URL.revokeObjectURL(link.href);
    }, "image/png");
}

// =====================================================
async function loadRawFile(url, width, height, depth) {
    const response = await fetch(url);
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const buffer = await response.arrayBuffer();
    const data = new Uint8Array(buffer);

    const expectedSize = width * height * depth;
    if (data.length !== expectedSize) {
        console.error(
            `Taille des données incorrecte : attendue ${expectedSize}, reçue ${data.length}`
        );
        return null;
    }

    const texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_3D, texture);

    gl.texImage3D(
        gl.TEXTURE_3D,
        0,
        gl.R8,
        width,
        height,
        depth,
        0,
        gl.RED,
        gl.UNSIGNED_BYTE,
        data
    ); // 1 canal, 8 bits par pixel, donc on utilise gl.R8 et gl.RED

    gl.texParameteri(gl.TEXTURE_3D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_3D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_3D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_3D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_3D, gl.TEXTURE_WRAP_R, gl.CLAMP_TO_EDGE);

    gl.bindTexture(gl.TEXTURE_3D, null);

    return texture;
}

// =====================================================
function compileShaders(Obj3D) {
    Obj3D.vshader = gl.createShader(gl.VERTEX_SHADER);
    gl.shaderSource(Obj3D.vshader, Obj3D.vsTxt);
    gl.compileShader(Obj3D.vshader);
    if (!gl.getShaderParameter(Obj3D.vshader, gl.COMPILE_STATUS)) {
        console.log("Vertex Shader FAILED... " + Obj3D.shaderName + ".vs");
        console.log(gl.getShaderInfoLog(Obj3D.vshader));
    }

    Obj3D.fshader = gl.createShader(gl.FRAGMENT_SHADER);
    gl.shaderSource(Obj3D.fshader, Obj3D.fsTxt);
    gl.compileShader(Obj3D.fshader);
    if (!gl.getShaderParameter(Obj3D.fshader, gl.COMPILE_STATUS)) {
        console.log("Fragment Shader FAILED... " + Obj3D.shaderName + ".fs");
        console.log(gl.getShaderInfoLog(Obj3D.fshader));
    }

    Obj3D.shader = gl.createProgram();
    gl.attachShader(Obj3D.shader, Obj3D.vshader);
    gl.attachShader(Obj3D.shader, Obj3D.fshader);
    gl.linkProgram(Obj3D.shader);
    if (!gl.getProgramParameter(Obj3D.shader, gl.LINK_STATUS)) {
        console.log("Could not initialise shaders");
        console.log(gl.getShaderInfoLog(Obj3D.shader));
    }
}

// =====================================================
// Code from https://developer.mozilla.org/en-US/docs/Web/API/WebGL_API/Tutorial/Using_textures_in_WebGL
function load2DTextureBufferFromURL(url) {
    var texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);

    const level = 0;
    const internalFormat = gl.RGBA;
    const width = 1;
    const height = 1;
    const border = 0;
    const srcFormat = gl.RGBA;
    const srcType = gl.UNSIGNED_BYTE;
    const pixel = new Uint8Array([0, 0, 255, 255]); // opaque blue
    gl.texImage2D(
        gl.TEXTURE_2D,
        level,
        internalFormat,
        width,
        height,
        border,
        srcFormat,
        srcType,
        pixel
    );

    const image = new Image();
    image.onload = () => {
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texImage2D(
            gl.TEXTURE_2D,
            level,
            internalFormat,
            srcFormat,
            srcType,
            image
        );

        gl.generateMipmap(gl.TEXTURE_2D);
    };

    image.src = url;

    return texture;
}

function load2DTextureBufferFromImage(image) {
    var texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);

    const level = 0;
    const internalFormat = gl.RGBA;
    const width = 1;
    const height = 1;
    const border = 0;
    const srcFormat = gl.RGBA;
    const srcType = gl.UNSIGNED_BYTE;
    const pixel = new Uint8Array([0, 0, 255, 255]); // opaque blue
    gl.texImage2D(
        gl.TEXTURE_2D,
        level,
        internalFormat,
        width,
        height,
        border,
        srcFormat,
        srcType,
        pixel
    );

    if (image) {
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texImage2D(
            gl.TEXTURE_2D,
            level,
            internalFormat,
            srcFormat,
            srcType,
            image
        );

        gl.generateMipmap(gl.TEXTURE_2D);
    }

    return texture;
}

// =====================================================
// OBJET 3D, classe de base
// =====================================================

class ThreeDObject {
    constructor(position, rotation, shaderName = "obj") {
        this.shaderName = shaderName;
        this.position = position;
        this.rotation = rotation;

        this.shader = null;
        this.loaded = -1;
        this.mesh = null;
    }

    // --------------------------------------------
    setShadersParams() {
        console.warn("setShadersParams not implemented");
    }

    // --------------------------------------------
    setMatrixUniforms() {
        mat4.identity(mvMatrix);
        mat4.translate(mvMatrix, distCENTER);
        mat4.multiply(mvMatrix, rotMatrix);

        mat4.translate(mvMatrix, this.position);

        mat4.rotate(mvMatrix, this.rotation[0], [1, 0, 0]);
        mat4.rotate(mvMatrix, this.rotation[1], [0, 1, 0]);
        mat4.rotate(mvMatrix, this.rotation[2], [0, 0, 1]);

        gl.uniformMatrix4fv(this.shader.rMatrixUniform, false, rotMatrix);
        gl.uniformMatrix4fv(this.shader.mvMatrixUniform, false, mvMatrix);
        gl.uniformMatrix4fv(this.shader.pMatrixUniform, false, pMatrix);
    }

    // --------------------------------------------
    draw() {
        if (this.shader && this.loaded == 4 && this.mesh != null) {
            this.setShadersParams();
            this.setMatrixUniforms();
            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.mesh.indexBuffer);
            gl.drawElements(
                gl.TRIANGLES,
                this.mesh.indexBuffer.numItems,
                gl.UNSIGNED_INT,
                0
            );
        }
    }

    setPosition(pos) {
        this.position = pos;
    }

    setRotation(rot) {
        this.rotation = rot;
    }
}

// =====================================================
// Abstract : Wireframe 3D Object
// =====================================================
class WireframeObject extends ThreeDObject {
    constructor(
        position = [0, 0, 0],
        rotation = [0, 0, 0],
        shaderName = "obj",
        wireShaderName = "wire"
    ) {
        super(position, rotation, shaderName);
        this.wireShaderName = wireShaderName;
        this.wireActive = false;
    }

    switchWireState() {
        this.wireActive = !this.wireActive;
        if (this.wireActive) {
            loadShaders(this, this.wireShaderName);
        } else {
            loadShaders(this);
        }
    }

    getWireState() {
        return this.wireActive;
    }

    setShadersParams() {
        gl.useProgram(this.shader);

        this.shader.vAttrib = gl.getAttribLocation(
            this.shader,
            "aVertexPosition"
        );
        gl.enableVertexAttribArray(this.shader.vAttrib);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.mesh.vertexBuffer);
        gl.vertexAttribPointer(
            this.shader.vAttrib,
            this.mesh.vertexBuffer.itemSize,
            gl.FLOAT,
            false,
            0,
            0
        );

        this.shader.rMatrixUniform = gl.getUniformLocation(
            this.shader,
            "uRMatrix"
        );
        this.shader.mvMatrixUniform = gl.getUniformLocation(
            this.shader,
            "uMVMatrix"
        );
        this.shader.pMatrixUniform = gl.getUniformLocation(
            this.shader,
            "uPMatrix"
        );
    }

    draw() {
        if (this.wireActive) {
            this.setShadersParams();
            this.setMatrixUniforms();
            gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.mesh.indexBuffer);
            gl.drawElements(
                gl.LINES,
                this.mesh.indexBuffer.numItems,
                gl.UNSIGNED_INT,
                0
            );
        } else {
            super.draw();
        }
    }
}

// =====================================================
// PLAN 3D
// =====================================================

class plane extends ThreeDObject {
    // --------------------------------------------
    constructor(
        x = -1,
        y = -1,
        z = 0,
        dx = 2.0,
        dy = 2.0,
        position = [0, 0, 0],
        rotation = [0, 0, 0]
    ) {
        super(position, rotation, "plane");
        this.x = x;
        this.y = y;
        this.z = z;
        this.dx = dx;
        this.dy = dy;
        this.loaded = -1;
        this.shader = null;
        this.mesh = {};

        this.initAll();
        loadShaders(this);
    }

    // --------------------------------------------
    initAll() {
        var vertices = [
            this.x,
            this.y,
            this.z,
            this.x + this.dx,
            this.y,
            this.z,
            this.x + this.dx,
            this.y + this.dy,
            this.z,
            this.x,
            this.y + this.dy,
            this.z,
        ];

        var texcoords = [0.0, 0.0, 0.0, 1.0, 1.0, 1.0, 1.0, 0.0];

        this.mesh.vertexBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.mesh.vertexBuffer);
        gl.bufferData(
            gl.ARRAY_BUFFER,
            new Float32Array(vertices),
            gl.STATIC_DRAW
        );
        this.mesh.vertexBuffer.itemSize = 3;
        this.mesh.vertexBuffer.numItems = 4;

        this.mesh.normalBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.mesh.normalBuffer);
        gl.bufferData(
            gl.ARRAY_BUFFER,
            new Float32Array(texcoords),
            gl.STATIC_DRAW
        );
        this.mesh.normalBuffer.itemSize = 2;
        this.mesh.normalBuffer.numItems = 4;
    }

    // --------------------------------------------
    setShadersParams() {
        gl.useProgram(this.shader);

        this.shader.vAttrib = gl.getAttribLocation(
            this.shader,
            "aVertexPosition"
        );
        gl.enableVertexAttribArray(this.shader.vAttrib);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.mesh.vertexBuffer);
        gl.vertexAttribPointer(
            this.shader.vAttrib,
            this.mesh.vertexBuffer.itemSize,
            gl.FLOAT,
            false,
            0,
            0
        );

        this.shader.tAttrib = gl.getAttribLocation(this.shader, "aTexCoords");
        gl.enableVertexAttribArray(this.shader.tAttrib);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.mesh.normalBuffer);
        gl.vertexAttribPointer(
            this.shader.tAttrib,
            this.mesh.normalBuffer.itemSize,
            gl.FLOAT,
            false,
            0,
            0
        );

        this.shader.pMatrixUniform = gl.getUniformLocation(
            this.shader,
            "uPMatrix"
        );
        this.shader.mvMatrixUniform = gl.getUniformLocation(
            this.shader,
            "uMVMatrix"
        );
    }

    // --------------------------------------------
    draw() {
        if (this.shader && this.loaded == 4) {
            this.setShadersParams();
            this.setMatrixUniforms();

            gl.drawArrays(gl.TRIANGLE_FAN, 0, this.mesh.vertexBuffer.numItems);
            gl.drawArrays(gl.LINE_LOOP, 0, this.mesh.vertexBuffer.numItems);
        }
    }
}

// =====================================================
// OBJET 3D, lecture fichier obj
// =====================================================
class objmesh extends WireframeObject {
    // --------------------------------------------
    constructor(
        objFname,
        position = [0, 0, 0],
        rotation = [0, 0, 0],
        color = [1, 1, 1],
        lightPos = [0.0, 0.0, 0.0],
        ambientLight = [0.2, 0.2, 0.2, 1.0],
        lightColor = [1.0, 1.0, 1.0, 1.0],
        shininess = 320.0
    ) {
        super(position, rotation);

        this.objFname = objFname;
        this.color = color;

        this.lightPos = lightPos;
        this.ambientLight = ambientLight;
        this.lightColor = lightColor;
        this.shininess = shininess;
        this.useTexture = true;

        this.initAll();
        loadShaders(this);
    }

    initAll() {
        loadObjFile(this);
    }

    endLoad() {
        this.mesh.textureImage = load2DTextureBufferFromURL(text_obj_texture);
    }

    setShadersParams() {
        if (this.wireActive) {
            super.setShadersParams();
            return;
        }

        gl.useProgram(this.shader);

        this.shader.vAttrib = gl.getAttribLocation(
            this.shader,
            "aVertexPosition"
        );
        gl.enableVertexAttribArray(this.shader.vAttrib);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.mesh.vertexBuffer);
        gl.vertexAttribPointer(
            this.shader.vAttrib,
            this.mesh.vertexBuffer.itemSize,
            gl.FLOAT,
            false,
            0,
            0
        );

        this.shader.nAttrib = gl.getAttribLocation(
            this.shader,
            "aVertexNormal"
        );
        gl.enableVertexAttribArray(this.shader.nAttrib);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.mesh.normalBuffer);
        gl.vertexAttribPointer(
            this.shader.nAttrib,
            this.mesh.normalBuffer.itemSize,
            gl.FLOAT,
            false,
            0,
            0
        );

        this.shader.tAttrib = gl.getAttribLocation(
            this.shader,
            "aTextureCoord"
        );
        gl.enableVertexAttribArray(this.shader.tAttrib);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.mesh.textureBuffer);
        gl.vertexAttribPointer(
            this.shader.tAttrib,
            this.mesh.textureBuffer.itemSize,
            gl.FLOAT,
            false,
            0,
            0
        );

        this.shader.rMatrixUniform = gl.getUniformLocation(
            this.shader,
            "uRMatrix"
        );
        this.shader.mvMatrixUniform = gl.getUniformLocation(
            this.shader,
            "uMVMatrix"
        );
        this.shader.pMatrixUniform = gl.getUniformLocation(
            this.shader,
            "uPMatrix"
        );
        this.shader.uColor = gl.getUniformLocation(this.shader, "uColor");
        this.shader.uUseTexture = gl.getUniformLocation(
            this.shader,
            "uUseTexture"
        );
        this.shader.uSampler = gl.getUniformLocation(this.shader, "uSampler");
        this.shader.uLightPos = gl.getUniformLocation(this.shader, "uLightPos");
        this.shader.uAmbientColor = gl.getUniformLocation(
            this.shader,
            "uAmbientColor"
        );
        this.shader.uLightColor = gl.getUniformLocation(
            this.shader,
            "uLightColor"
        );
        this.shader.uShininess = gl.getUniformLocation(
            this.shader,
            "uShininess"
        );
        this.shader.uUseNormalMap = gl.getUniformLocation(
            this.shader,
            "uUseNormalMap"
        );
        this.shader.uNormalMap = gl.getUniformLocation(
            this.shader,
            "uNormalMap"
        );

        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, this.mesh.textureImage);
        gl.uniform1i(this.shader.uSampler, 0);
    }

    // --------------------------------------------
    setMatrixUniforms() {
        super.setMatrixUniforms();
        if (this.wireActive) {
            return;
        }
        gl.uniform3f(
            this.shader.uColor,
            this.color[0],
            this.color[1],
            this.color[2]
        );
        gl.uniform4f(
            this.shader.uLightColor,
            this.lightColor[0],
            this.lightColor[1],
            this.lightColor[2],
            this.lightColor[3]
        );
        gl.uniform3f(
            this.shader.uLightPos,
            this.lightPos[0],
            this.lightPos[1],
            this.lightPos[2]
        );
        gl.uniform4f(
            this.shader.uAmbientColor,
            this.ambientLight[0],
            this.ambientLight[1],
            this.ambientLight[2],
            this.ambientLight[3]
        );
        gl.uniform1i(this.shader.uUseTexture, this.useTexture ? 1 : 0);
        gl.uniform1i(this.shader.uUseNormalMap, 0);
        gl.uniform1f(this.shader.uShininess, this.shininess);
    }

    // --------------------------------------------
    setColor(col) {
        this.color = col;
    }

    switchTextureState() {
        this.useTexture = !this.useTexture;
    }

    getTextureState() {
        return this.useTexture;
    }
}

// =====================================================
// MAP 3D, construit a partir d'une heightmap
// =====================================================

class map3D extends WireframeObject {
    constructor(
        map,
        position = [0, 0, 0],
        rotation = [0, 0, 0],
        color = [1, 1, 1],
        ampl = 1.5,
        x = -1,
        y = -1,
        z = 0,
        dx = 2.0,
        dy = 2.0,
        lightPos = [0.0, 0.0, 0.0],
        ambientLight = [0.1, 0.1, 0.1, 1.0],
        lightColor = [1.0, 1.0, 1.0, 1.0],
        shininess = 1024.0,
        waterLevel = 0.08
    ) {
        super(position, rotation, "heightmaps");

        this.map = map;
        this.color = color;
        this.mesh = {
            vertices: [],
            vertexNormals: [],
            textures: [],
            indices: [],
            vertexBuffer: null,
            normalBuffer: null,
            indexBuffer: null,
            textureBuffer: null,
        };
        this.width = map.length;
        this.height = map[0].length;
        this.x = x;
        this.y = y;
        this.z = z;
        this.dx = dx;
        this.dy = dy;
        this.ampl = 0.5;
        this.lightColor = lightColor;
        this.lightPos = lightPos;
        this.ambientLight = ambientLight;
        this.shininess = shininess;
        this.waterLevel = waterLevel;
        this.useTexture = true;
        this.useNormalMap = true;

        this.initAll();

        loadShaders(this);
    }

    initAll() {
        let index = 0;

        // Calcul des coordonnées
        for (let i = 0; i < this.width; i++) {
            for (let j = 0; j < this.height; j++) {
                // Coordonnées des 4 sommets formant les 2 triangles
                const x1 = this.x + (i / this.width) * this.dx;
                const y1 = this.y + (j / this.height) * this.dy;
                const z1 = this.map[i][j] * this.ampl;

                // On ajoute les coordonnées des sommets (2 * 3 sommets)
                this.mesh.vertices.push(x1, y1, z1);
            }
        }

        // Création des indices
        for (let i = 0; i < this.width - 1; i++) {
            for (let j = 0; j < this.height - 1; j++) {
                const index1 = i * this.width + j;
                const index2 = (i + 1) * this.width + j;
                const index3 = (i + 1) * this.width + j + 1;
                const index4 = i * this.width + j + 1;

                this.mesh.indices.push(index1, index2, index3);
                this.mesh.indices.push(index1, index3, index4);
            }
        }

        // Calcul des coordonnées de texture
        for (let i = 0; i < this.mesh.vertices.length; i += 3) {
            const x = this.mesh.vertices[i];
            const y = this.mesh.vertices[i + 1];

            const u = (x - this.x) / this.dx;
            const v = (y - this.y) / this.dy;

            this.mesh.textures.push(u, v);
        }

        // Calcul des normales
        // Version optimisable en utilisant les valeurs déjà calculées
        for (let i = 0; i < this.width; i++) {
            for (let j = 0; j < this.height; j++) {
                const ip = Math.min(i + 1, this.width - 1);
                const jp = Math.min(j + 1, this.height - 1);

                const x1 = this.x + (i / this.width) * this.dx;
                const y1 = this.y + (j / this.height) * this.dy;
                const z1 = this.map[i][j] * this.ampl;

                const x2 = this.x + (ip / this.width) * this.dx;
                const y2 = this.y + (j / this.height) * this.dy;
                const z2 = this.map[ip][j] * this.ampl;

                const x3 = this.x + (ip / this.width) * this.dx;
                const y3 = this.y + (jp / this.height) * this.dy;
                const z3 = this.map[ip][jp] * this.ampl;

                const x4 = this.x + (i / this.width) * this.dx;
                const y4 = this.y + (jp / this.height) * this.dy;
                const z4 = this.map[i][jp] * this.ampl;

                const v1 = vec3.create([x2 - x1, y2 - y1, z2 - z1]);
                const v2 = vec3.create([x3 - x2, y3 - y2, z3 - z2]);
                const n1 = vec3.create();
                vec3.cross(v1, v2, n1);
                vec3.normalize(n1);

                const v3 = vec3.create([x3 - x1, y3 - y1, z3 - z1]);
                const v4 = vec3.create([x4 - x3, y4 - y3, z4 - z3]);
                const n2 = vec3.create();
                vec3.cross(v3, v4, n2);
                vec3.normalize(n2);

                const n = vec3.create();
                vec3.add(n1, n2, n);
                vec3.normalize(n);

                this.mesh.vertexNormals.push(n[0], n[1], n[2]);
            }
        }

        // Création et remplissage des buffers WebGL pour vertices et normales
        this.mesh.vertexBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.mesh.vertexBuffer);
        gl.bufferData(
            gl.ARRAY_BUFFER,
            new Float32Array(this.mesh.vertices),
            gl.STATIC_DRAW
        );
        this.mesh.vertexBuffer.itemSize = 3;
        this.mesh.vertexBuffer.numItems = this.mesh.vertices.length / 3;

        this.mesh.normalBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.mesh.normalBuffer);
        gl.bufferData(
            gl.ARRAY_BUFFER,
            new Float32Array(this.mesh.vertexNormals),
            gl.STATIC_DRAW
        );
        this.mesh.normalBuffer.itemSize = 3;
        this.mesh.normalBuffer.numItems = this.mesh.vertexNormals.length / 3;

        this.mesh.textureBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.mesh.textureBuffer);
        gl.bufferData(
            gl.ARRAY_BUFFER,
            new Float32Array(this.mesh.textures),
            gl.STATIC_DRAW
        );
        this.mesh.textureBuffer.itemSize = 2;
        this.mesh.textureBuffer.numItems = this.mesh.textures.length / 2;

        this.mesh.indexBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.mesh.indexBuffer);
        gl.bufferData(
            gl.ELEMENT_ARRAY_BUFFER,
            new Uint32Array(this.mesh.indices),
            gl.STATIC_DRAW
        );
        this.mesh.indexBuffer.itemSize = 1;
        this.mesh.indexBuffer.numItems = this.mesh.indices.length;

        this.mesh.texture = load2DTextureBufferFromURL(text_floor);
        this.mesh.heightTexture = load2DTextureBufferFromURL(text_height_color);
        this.mesh.normalMap = load2DTextureBufferFromURL(norm_water);
    }

    // Définir les paramètres des shaders
    setShadersParams() {
        if (this.wireActive) {
            super.setShadersParams();
            return;
        }

        gl.useProgram(this.shader);

        this.shader.vAttrib = gl.getAttribLocation(
            this.shader,
            "aVertexPosition"
        );
        gl.enableVertexAttribArray(this.shader.vAttrib);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.mesh.vertexBuffer);
        gl.vertexAttribPointer(
            this.shader.vAttrib,
            this.mesh.vertexBuffer.itemSize,
            gl.FLOAT,
            false,
            0,
            0
        );

        this.shader.nAttrib = gl.getAttribLocation(
            this.shader,
            "aVertexNormal"
        );
        gl.enableVertexAttribArray(this.shader.nAttrib);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.mesh.normalBuffer);
        gl.vertexAttribPointer(
            this.shader.nAttrib,
            this.mesh.vertexBuffer.itemSize,
            gl.FLOAT,
            false,
            0,
            0
        );

        this.shader.tAttrib = gl.getAttribLocation(
            this.shader,
            "aTextureCoord"
        );
        gl.enableVertexAttribArray(this.shader.tAttrib);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.mesh.textureBuffer);
        gl.vertexAttribPointer(
            this.shader.tAttrib,
            this.mesh.textureBuffer.itemSize,
            gl.FLOAT,
            false,
            0,
            0
        );

        this.shader.rMatrixUniform = gl.getUniformLocation(
            this.shader,
            "uRMatrix"
        );
        this.shader.mvMatrixUniform = gl.getUniformLocation(
            this.shader,
            "uMVMatrix"
        );
        this.shader.pMatrixUniform = gl.getUniformLocation(
            this.shader,
            "uPMatrix"
        );
        this.shader.uSampler = gl.getUniformLocation(this.shader, "uSampler");
        this.shader.uHeightSampler = gl.getUniformLocation(
            this.shader,
            "uHeightSampler"
        );
        this.shader.uNormalMap = gl.getUniformLocation(
            this.shader,
            "uNormalMap"
        );
        this.shader.uUseNormalMap = gl.getUniformLocation(
            this.shader,
            "uUseNormalMap"
        );
        this.shader.uLightColor = gl.getUniformLocation(
            this.shader,
            "uLightColor"
        );
        this.shader.uAmbientColor = gl.getUniformLocation(
            this.shader,
            "uAmbientColor"
        );
        this.shader.uLightPos = gl.getUniformLocation(this.shader, "uLightPos");
        this.shader.uShininess = gl.getUniformLocation(
            this.shader,
            "uShininess"
        );
        this.shader.uWaterLevel = gl.getUniformLocation(
            this.shader,
            "uWaterLevel"
        );
        this.shader.uUseTexture = gl.getUniformLocation(
            this.shader,
            "uUseTexture"
        );
        this.shader.uColor = gl.getUniformLocation(this.shader, "uColor");

        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, this.mesh.texture);
        gl.uniform1i(this.shader.uSampler, 0);

        gl.activeTexture(gl.TEXTURE1);
        gl.bindTexture(gl.TEXTURE_2D, this.mesh.heightTexture);
        gl.uniform1i(this.shader.uHeightSampler, 1);

        gl.activeTexture(gl.TEXTURE2);
        gl.bindTexture(gl.TEXTURE_2D, this.mesh.normalMap);
        gl.uniform1i(this.shader.uNormalMap, 2);
    }

    // Définir les matrices des shaders
    setMatrixUniforms() {
        super.setMatrixUniforms();
        if (this.wireActive) {
            return;
        }
        gl.uniform4f(
            this.shader.uLightColor,
            this.lightColor[0],
            this.lightColor[1],
            this.lightColor[2],
            this.lightColor[3]
        );
        gl.uniform3f(
            this.shader.uLightPos,
            this.lightPos[0],
            this.lightPos[1],
            this.lightPos[2]
        );
        gl.uniform4f(
            this.shader.uAmbientColor,
            this.ambientLight[0],
            this.ambientLight[1],
            this.ambientLight[2],
            this.ambientLight[3]
        );
        gl.uniform1f(this.shader.uShininess, this.shininess);
        gl.uniform1i(this.shader.uUseNormalMap, this.useNormalMap ? 1 : 0);
        gl.uniform1f(this.shader.uWaterLevel, this.waterLevel);
        gl.uniform1i(this.shader.uUseTexture, this.useTexture ? 1 : 0);
        gl.uniform3f(
            this.shader.uColor,
            this.color[0],
            this.color[1],
            this.color[2]
        );
    }

    // Changer la couleur de l'objet
    setColor(col) {
        this.color = col;
    }

    switchTextureState() {
        this.useTexture = !this.useTexture;
    }

    getTextureState() {
        return this.useTexture;
    }

    switchNormalState() {
        this.useNormalMap = !this.useNormalMap;
    }

    getNormalState() {
        return this.useNormalMap;
    }
}

// =====================================================
// BOITE ENGLOBEANTE
// =====================================================

class BoundingBox extends WireframeObject {
    constructor(
        position = [0, 0, 0],
        rotation = [0, 0, 0],
        color = [1, 1, 1],
        x = -1,
        y = -1,
        z = 0,
        dx = 2.0,
        dy = 2.0,
        dz = 2.0,
        amplitude = 0.1
    ) {
        super(position, rotation, "box");
        this.color = color;
        this.amplitude = amplitude;
        this.x = x;
        this.y = y;
        this.z = z;
        this.dx = dx;
        this.dy = dy;
        this.dz = dz;

        this.mesh = {};
        this.useTexture = true;

        this.initAll();
        loadShaders(this);
    }

    initAll() {
        this.mesh.vertices = [
            this.x,
            this.y,
            this.z,
            this.x + this.dx,
            this.y,
            this.z,
            this.x + this.dx,
            this.y + this.dy,
            this.z,
            this.x,
            this.y + this.dy,
            this.z,
            this.x,
            this.y,
            this.z + this.dz,
            this.x + this.dx,
            this.y,
            this.z + this.dz,
            this.x + this.dx,
            this.y + this.dy,
            this.z + this.dz,
            this.x,
            this.y + this.dy,
            this.z + this.dz,
        ];

        this.mesh.indices = [
            0, 2, 1, 0, 3, 2, 0, 1, 4, 0, 4, 3, 1, 2, 6, 1, 5, 4, 1, 6, 5, 2, 3,
            6, 3, 4, 7, 3, 7, 6, 4, 5, 7, 5, 6, 7,
        ];

        this.mesh.normals = [
            -1.0, -1.0, -1.0, 1.0, -1.0, -1.0, 1.0, 1.0, -1.0, -1.0, 1.0, -1.0,
            -1.0, -1.0, 1.0, 1.0, -1.0, 1.0, 1.0, 1.0, 1.0, -1.0, 1.0, 1.0,
        ];

        this.mesh.vertexBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.mesh.vertexBuffer);
        gl.bufferData(
            gl.ARRAY_BUFFER,
            new Float32Array(this.mesh.vertices),
            gl.STATIC_DRAW
        );
        this.mesh.vertexBuffer.itemSize = 3;
        this.mesh.vertexBuffer.numItems = this.mesh.vertices.length / 3;

        this.mesh.indexBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.mesh.indexBuffer);
        gl.bufferData(
            gl.ELEMENT_ARRAY_BUFFER,
            new Uint32Array(this.mesh.indices),
            gl.STATIC_DRAW
        );
        this.mesh.indexBuffer.itemSize = 1;
        this.mesh.indexBuffer.numItems = this.mesh.indices.length;

        this.mesh.normalBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.mesh.normalBuffer);
        gl.bufferData(
            gl.ARRAY_BUFFER,
            new Float32Array(this.mesh.normals),
            gl.STATIC_DRAW
        );
        this.mesh.normalBuffer.itemSize = 3;
        this.mesh.vertexBuffer.numItems = this.mesh.normals.length / 3;

        this.mesh.heightmap = load2DTextureBufferFromImage(
            selectedHeightmapImage
        );
        this.mesh.texture = load2DTextureBufferFromURL(text_floor);
        this.mesh.heightTexture = load2DTextureBufferFromURL(text_height_color);
        this.mesh.normalMap = load2DTextureBufferFromURL(norm_water);
    }

    setShadersParams() {
        if (this.wireActive) {
            super.setShadersParams();
            return;
        }

        gl.useProgram(this.shader);

        this.shader.vAttrib = gl.getAttribLocation(
            this.shader,
            "aVertexPosition"
        );
        gl.enableVertexAttribArray(this.shader.vAttrib);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.mesh.vertexBuffer);
        gl.vertexAttribPointer(
            this.shader.vAttrib,
            this.mesh.vertexBuffer.itemSize,
            gl.FLOAT,
            false,
            0,
            0
        );

        this.shader.nAttrib = gl.getAttribLocation(
            this.shader,
            "aVertexNormal"
        );
        gl.enableVertexAttribArray(this.shader.nAttrib);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.mesh.normalBuffer);
        gl.vertexAttribPointer(
            this.shader.nAttrib,
            this.mesh.normalBuffer.itemSize,
            gl.FLOAT,
            false,
            0,
            0
        );

        this.shader.rMatrixUniform = gl.getUniformLocation(
            this.shader,
            "uRMatrix"
        );
        this.shader.mvMatrixUniform = gl.getUniformLocation(
            this.shader,
            "uMVMatrix"
        );
        this.shader.pMatrixUniform = gl.getUniformLocation(
            this.shader,
            "uPMatrix"
        );
        this.shader.uColor = gl.getUniformLocation(this.shader, "uColor");
        this.shader.uUseTexture = gl.getUniformLocation(
            this.shader,
            "uUseTexture"
        );
        this.shader.uHeightmap = gl.getUniformLocation(
            this.shader,
            "uHeightmap"
        );
        this.shader.uLightPos = gl.getUniformLocation(this.shader, "uLightPos");
        this.shader.uAmbientColor = gl.getUniformLocation(
            this.shader,
            "uAmbientColor"
        );
        this.shader.uLightColor = gl.getUniformLocation(
            this.shader,
            "uLightColor"
        );
        this.shader.uShininess = gl.getUniformLocation(
            this.shader,
            "uShininess"
        );
        this.shader.uUseNormalMap = gl.getUniformLocation(
            this.shader,
            "uUseNormalMap"
        );
        this.shader.uNormalMap = gl.getUniformLocation(
            this.shader,
            "uNormalMap"
        );
        this.shader.uCameraParams = gl.getUniformLocation(
            this.shader,
            "uCameraParams"
        );
        this.shader.uAmplitude = gl.getUniformLocation(
            this.shader,
            "uAmplitude"
        );
        this.shader.uSampler = gl.getUniformLocation(this.shader, "uSampler");
        this.shader.uHeightSampler = gl.getUniformLocation(
            this.shader,
            "uHeightSampler"
        );
        this.shader.uWaterLevel = gl.getUniformLocation(
            this.shader,
            "uWaterLevel"
        );

        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, this.mesh.heightmap);
        gl.uniform1i(this.shader.uHeightmap, 0);

        gl.activeTexture(gl.TEXTURE1);
        gl.bindTexture(gl.TEXTURE_2D, this.mesh.texture);
        gl.uniform1i(this.shader.uSampler, 1);

        gl.activeTexture(gl.TEXTURE2);
        gl.bindTexture(gl.TEXTURE_2D, this.mesh.heightTexture);
        gl.uniform1i(this.shader.uHeightSampler, 2);

        gl.activeTexture(gl.TEXTURE3);
        gl.bindTexture(gl.TEXTURE_2D, this.mesh.normalMap);
        gl.uniform1i(this.shader.uNormalMap, 3);
    }

    // --------------------------------------------
    setMatrixUniforms() {
        super.setMatrixUniforms();
        if (this.wireActive) {
            return;
        }
        gl.uniform3f(
            this.shader.uColor,
            this.color[0],
            this.color[1],
            this.color[2]
        );
        gl.uniform3f(
            this.shader.uCameraParams,
            canvas.width,
            canvas.height,
            45.0
        );
        gl.uniform1f(this.shader.uAmplitude, this.amplitude);
        gl.uniform4f(this.shader.uLightColor, 1.0, 1.0, 1.0, 1.0);
        gl.uniform3f(this.shader.uLightPos, -0.5, -1.0, 2.0);
        gl.uniform4f(this.shader.uAmbientColor, 0.2, 0.2, 0.2, 1.0);
        gl.uniform1i(this.shader.uUseTexture, this.useTexture ? 1 : 0);
        gl.uniform1i(this.shader.uUseNormalMap, 1);
        gl.uniform1f(this.shader.uShininess, 320.0);
        gl.uniform1f(this.shader.uWaterLevel, 0.08);
    }

    setColor(col) {
        this.color = col;
    }

    switchTextureState() {
        this.useTexture = !this.useTexture;
    }

    getTextureState() {
        return this.useTexture;
    }

    setAmplitude(amp) {
        this.amplitude = amp;
    }

    getAmplitude() {
        return this.amplitude;
    }
}

// =====================================================
// BOITE ENGLOBEANTE VOLUMIQUE
// =====================================================

class VolumeBox extends WireframeObject {
    constructor(
        tex3D = ["raw/hnut512_uint.raw", 512, 512, 512],
        position = [0, 0, 0],
        rotation = [0, 0, 0],
        color = [1, 1, 1],
        x = -1,
        y = -1,
        z = 0,
        dx = 2.0,
        dy = 2.0,
        dz = 2.0,
        amplitude = 0.1
    ) {
        super(position, rotation, "volume");
        this.color = color;
        this.amplitude = amplitude;
        this.x = x;
        this.y = y;
        this.z = z;
        this.dx = dx;
        this.dy = dy;
        this.dz = dz;

        this.mesh = {};
        this.useTexture = true;
        this.resolution = 512.0;
        this.tex3D = {
            url: tex3D[0],
            sizex: tex3D[1],
            sizey: tex3D[2],
            sizez: tex3D[3],
        };

        this.initAll().then(() => {
            loadShaders(this);
        });
    }

    async initAll() {
        this.mesh.vertices = [
            this.x,
            this.y,
            this.z,
            this.x + this.dx,
            this.y,
            this.z,
            this.x + this.dx,
            this.y + this.dy,
            this.z,
            this.x,
            this.y + this.dy,
            this.z,
            this.x,
            this.y,
            this.z + this.dz,
            this.x + this.dx,
            this.y,
            this.z + this.dz,
            this.x + this.dx,
            this.y + this.dy,
            this.z + this.dz,
            this.x,
            this.y + this.dy,
            this.z + this.dz,
        ];

        this.mesh.indices = [
            0, 2, 1, 0, 3, 2, 0, 1, 4, 0, 4, 3, 1, 2, 6, 1, 5, 4, 1, 6, 5, 2, 3,
            6, 3, 4, 7, 3, 7, 6, 4, 5, 7, 5, 6, 7,
        ];

        this.mesh.normals = [
            -1.0, -1.0, -1.0, 1.0, -1.0, -1.0, 1.0, 1.0, -1.0, -1.0, 1.0, -1.0,
            -1.0, -1.0, 1.0, 1.0, -1.0, 1.0, 1.0, 1.0, 1.0, -1.0, 1.0, 1.0,
        ];

        this.mesh.vertexBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.mesh.vertexBuffer);
        gl.bufferData(
            gl.ARRAY_BUFFER,
            new Float32Array(this.mesh.vertices),
            gl.STATIC_DRAW
        );
        this.mesh.vertexBuffer.itemSize = 3;
        this.mesh.vertexBuffer.numItems = this.mesh.vertices.length / 3;

        this.mesh.indexBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, this.mesh.indexBuffer);
        gl.bufferData(
            gl.ELEMENT_ARRAY_BUFFER,
            new Uint32Array(this.mesh.indices),
            gl.STATIC_DRAW
        );
        this.mesh.indexBuffer.itemSize = 1;
        this.mesh.indexBuffer.numItems = this.mesh.indices.length;

        this.mesh.normalBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.mesh.normalBuffer);
        gl.bufferData(
            gl.ARRAY_BUFFER,
            new Float32Array(this.mesh.normals),
            gl.STATIC_DRAW
        );
        this.mesh.normalBuffer.itemSize = 3;
        this.mesh.vertexBuffer.numItems = this.mesh.normals.length / 3;

        // this.mesh.heightmap = load2DTextureBufferFromImage(selectedHeightmapImage);
        // this.mesh.texture = load2DTextureBufferFromURL('textures/floor.jpg');
        // this.mesh.heightTexture = load2DTextureBufferFromURL('textures/height_color.png');
        // this.mesh.normalMap = load2DTextureBufferFromURL('normalmaps/water.jpg');

        // this.mesh.volumeTexture = await loadRawFile('raw/output.raw', 704, 704, 208).then((data) => {
        // 	return data;
        // });

        this.mesh.volumeTexture = await loadRawFile(
            this.tex3D.url,
            this.tex3D.sizex,
            this.tex3D.sizey,
            this.tex3D.sizez
        ).then((data) => {
            return data;
        });
    }

    setShadersParams() {
        if (this.wireActive) {
            super.setShadersParams();
            return;
        }

        gl.useProgram(this.shader);

        this.shader.vAttrib = gl.getAttribLocation(
            this.shader,
            "aVertexPosition"
        );
        gl.enableVertexAttribArray(this.shader.vAttrib);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.mesh.vertexBuffer);
        gl.vertexAttribPointer(
            this.shader.vAttrib,
            this.mesh.vertexBuffer.itemSize,
            gl.FLOAT,
            false,
            0,
            0
        );

        // this.shader.nAttrib = gl.getAttribLocation(this.shader, "aVertexNormal");
        // gl.enableVertexAttribArray(this.shader.nAttrib);
        // gl.bindBuffer(gl.ARRAY_BUFFER, this.mesh.normalBuffer);
        // gl.vertexAttribPointer(this.shader.nAttrib, this.mesh.normalBuffer.itemSize, gl.FLOAT, false, 0, 0);

        this.shader.rMatrixUniform = gl.getUniformLocation(
            this.shader,
            "uRMatrix"
        );
        this.shader.mvMatrixUniform = gl.getUniformLocation(
            this.shader,
            "uMVMatrix"
        );
        this.shader.pMatrixUniform = gl.getUniformLocation(
            this.shader,
            "uPMatrix"
        );
        this.shader.uClearColor = gl.getUniformLocation(
            this.shader,
            "uClearColor"
        );
        this.shader.uNbSamplers = gl.getUniformLocation(
            this.shader,
            "uNbSamplers"
        );
        this.shader.uResolution = gl.getUniformLocation(
            this.shader,
            "uResolution"
        );
        // this.shader.uUseTexture = gl.getUniformLocation(this.shader, "uUseTexture");
        // this.shader.uHeightmap = gl.getUniformLocation(this.shader, "uHeightmap");
        // this.shader.uLightPos = gl.getUniformLocation(this.shader, "uLightPos");
        // this.shader.uAmbientColor = gl.getUniformLocation(this.shader, "uAmbientColor");
        // this.shader.uLightColor = gl.getUniformLocation(this.shader, "uLightColor");
        // this.shader.uShininess = gl.getUniformLocation(this.shader, "uShininess");
        // this.shader.uUseNormalMap = gl.getUniformLocation(this.shader, "uUseNormalMap");
        // this.shader.uNormalMap = gl.getUniformLocation(this.shader, "uNormalMap");
        this.shader.uCameraParams = gl.getUniformLocation(
            this.shader,
            "uCameraParams"
        );

        this.shader.uVolumeSampler = gl.getUniformLocation(
            this.shader,
            "uVolumeSampler"
        );
        this.shader.uTransfertColor = gl.getUniformLocation(
            this.shader,
            "uTransfertColor"
        );
        this.shader.uMinThreshold = gl.getUniformLocation(
            this.shader,
            "uMinThreshold"
        );
        this.shader.uMaxThreshold = gl.getUniformLocation(
            this.shader,
            "uMaxThreshold"
        );

        // this.shader.uAmplitude = gl.getUniformLocation(this.shader, "uAmplitude");
        // this.shader.uSampler = gl.getUniformLocation(this.shader, "uSampler");
        // this.shader.uHeightSampler = gl.getUniformLocation(this.shader, "uHeightSampler");
        // this.shader.uWaterLevel = gl.getUniformLocation(this.shader, "uWaterLevel");

        // gl.activeTexture(gl.TEXTURE0);
        // gl.bindTexture(gl.TEXTURE_2D, this.mesh.heightmap);
        // gl.uniform1i(this.shader.uHeightmap, 0);

        // gl.activeTexture(gl.TEXTURE1);
        // gl.bindTexture(gl.TEXTURE_2D, this.mesh.texture);
        // gl.uniform1i(this.shader.uSampler, 1);

        // gl.activeTexture(gl.TEXTURE2);
        // gl.bindTexture(gl.TEXTURE_2D, this.mesh.heightTexture);
        // gl.uniform1i(this.shader.uHeightSampler, 2);

        // gl.activeTexture(gl.TEXTURE3);
        // gl.bindTexture(gl.TEXTURE_2D, this.mesh.normalMap);
        // gl.uniform1i(this.shader.uNormalMap, 3);

        // Passer la texture 3D au shader
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_3D, this.mesh.volumeTexture);
        gl.uniform1i(this.shader.uVolumeSampler, 0); // Passe la texture 3D à l'uniforme 'textures'
    }

    // --------------------------------------------
    setMatrixUniforms() {
        super.setMatrixUniforms();
        if (this.wireActive) {
            return;
        }
        gl.uniform4f(this.shader.uClearColor, 0.78, 0.89, 0.91, 1.0);
        gl.uniform3f(
            this.shader.uCameraParams,
            canvas.width,
            canvas.height,
            45.0
        );
        gl.uniform1f(this.shader.uResolution, this.resolution);
        gl.uniform4fv(this.shader.uTransfertColor, getColorRamp());
        gl.uniform1f(this.shader.uMinThreshold, getColorThreshMin());
        gl.uniform1f(this.shader.uMaxThreshold, getColorThreshMax());
        // gl.uniform1f(this.shader.uAmplitude, this.amplitude);
        // gl.uniform4f(this.shader.uLightColor, 1.0, 1.0, 1.0, 1.0);
        // gl.uniform3f(this.shader.uLightPos, -0.5, -1.0, 2.0);
        // gl.uniform4f(this.shader.uAmbientColor, 0.2, 0.2, 0.2, 1.0);
        // gl.uniform1i(this.shader.uUseTexture, this.useTexture ? 1 : 0);
        // gl.uniform1i(this.shader.uUseNormalMap, 1);
        // gl.uniform1f(this.shader.uShininess, 320.0);
        // gl.uniform1f(this.shader.uWaterLevel, 0.08);
    }

    setResolution(res) {
        this.resolution = res;
    }

    getResolution() {
        return this.resolution;
    }

    setColor(col) {
        this.color = col;
    }

    switchTextureState() {
        this.useTexture = !this.useTexture;
    }

    getTextureState() {
        return this.useTexture;
    }

    setAmplitude(amp) {
        this.amplitude = amp;
    }

    getAmplitude() {
        return this.amplitude;
    }
}

// heightmap.js

// Author : Léna PROUST & Tom BOIREAU

var heightmapFolder = "heightmaps/";

var selectedHeightmap = null;

var resultElem = null;

var selectedHeightmapImage = null;

// =====================================================
// FONCTIONS GENERALES, INITIALISATIONS
// =====================================================

function initHeightmap() {
    // Initialisation des éléments HTML
    resultElem = document.getElementById("heightmap-result");

    // Charger la heightmap
    handleGeneratePerlin();
}

// =====================================================
// FONCTIONS DE SELECTION
// =====================================================

// =====================================================
function getHeightmap() {
    return selectedHeightmap;
}

// =====================================================

import texture_1 from "url:./heightmaps/texture1.png";
import texture_2 from "url:./heightmaps/texture2.png";
import texture_3 from "url:./heightmaps/texture3.png";
import texture_4 from "url:./heightmaps/texture4.png";

const heightmapList = {
    "texture1.png": texture_1,
    "texture2.png": texture_2,
    "texture3.png": texture_3,
    "texture4.png": texture_4,
};

export function loadImage(imgName, divider = 1) {
    var img = new Image();
    img.src = heightmapList[imgName];
    img.onload = function () {
        var ctx = resultElem.getContext("2d");
        resultElem.width = img.width;
        resultElem.height = img.height;
        ctx.drawImage(img, 0, 0);

        selectedHeightmap = new Array(img.width / divider);

        for (var i = 0; i < img.width; i += divider) {
            selectedHeightmap[i / divider] = new Array(img.height / divider);
            for (var j = 0; j < img.height; j += divider) {
                var sum = 0;
                for (var k = 0; k < divider; k++) {
                    for (var l = 0; l < divider; l++) {
                        var data = ctx.getImageData(i + k, j + l, 1, 1).data;
                        // var height = data[0] /255.0; // couleur rgb
                        var height =
                            rgbToLab(data[0], data[1], data[2])[0] / 100.0; // couleur lab

                        sum += height;
                    }
                }
                var height = sum / (divider * divider);
                selectedHeightmap[i / divider][j / divider] = height;
            }
        }

        selectedHeightmapImage = img;
    };
}

let width = 512;
let height = 512;
let Ggradients = generateGradients(width, height);

export function resetGradients() {
    Ggradients = generateGradients(width, height);
    handleGeneratePerlin();
}

// =====================================================
function generateHeightmap(
    scale = 1,
    amplitude = 1,
    persistence = 0.5,
    octave = 2,
    contrast = 0.5,
    rgb = false
) {
    var heightmap = new Array(width);

    var ctx = resultElem.getContext("2d");
    resultElem.width = width;
    resultElem.height = height;

    const gradients = Ggradients;

    ctx.clearRect(0, 0, width + 1, height + 1);

    if (rgb) {
        for (var i = 0; i < width; i++) {
            heightmap[i] = new Array(height);
            for (var j = 0; j < height; j++) {
                let noiseR =
                    perlinOctaves(
                        i * scale,
                        j * scale,
                        gradients,
                        octave,
                        persistence
                    ) * amplitude;
                let noiseG =
                    perlinOctaves(
                        0.5 * i * scale,
                        1.5 * j * scale,
                        gradients,
                        octave,
                        persistence
                    ) * amplitude;
                let noiseB =
                    perlinOctaves(
                        1.5 * i * scale,
                        0.5 * j * scale,
                        gradients,
                        octave,
                        persistence
                    ) * amplitude;
                noiseR = adjustContrast(noiseR, contrast);
                noiseG = adjustContrast(noiseG, contrast);
                noiseB = adjustContrast(noiseB, contrast);
                // Normalisation entre -1 et 1, puis 0 à 1
                //noise = noise ;
                //noise = Math.max(0, Math.min(1, noise));

                heightmap[i][j] = (noiseR + noiseG + noiseB) / 3;

                // Utiliser le bruit pour définir une couleur en niveaux de gris
                let colorValueR = Math.floor(255 * noiseR);
                let colorValueG = Math.floor(255 * noiseG);
                let colorValueB = Math.floor(255 * noiseB);
                ctx.fillStyle = `rgb(${colorValueR}, ${colorValueG}, ${colorValueB})`;
                ctx.fillRect(i, j, 1, 1);
            }
        }
    } else {
        for (var i = 0; i < width; i++) {
            heightmap[i] = new Array(height);
            for (var j = 0; j < height; j++) {
                let noise =
                    perlinOctaves(
                        i * scale,
                        j * scale,
                        gradients,
                        octave,
                        persistence
                    ) * amplitude;
                noise = adjustContrast(noise, contrast);
                // Normalisation entre -1 et 1, puis 0 à 1
                //noise = noise ;
                //noise = Math.max(0, Math.min(1, noise));

                heightmap[i][j] = noise;

                // Utiliser le bruit pour définir une couleur en niveaux de gris
                let colorValue = Math.floor(255 * noise);
                ctx.fillStyle = `rgb(${colorValue}, ${colorValue}, ${colorValue})`;
                ctx.fillRect(i, j, 1, 1);
            }
        }
    }

    selectedHeightmap = heightmap;
    selectedHeightmapImage = new Image();
    selectedHeightmapImage.src = resultElem.toDataURL();
}

// =====================================================
export function handleGeneratePerlin() {
    var rgb = document.getElementById("perlin-rgb").checked;
    var scale = parseFloat(document.getElementById("perlin-scale").value);
    var amplitude = parseFloat(
        document.getElementById("perlin-amplitude").value
    );
    var persistence = parseFloat(
        document.getElementById("perlin-persistence").value
    );
    var octave = parseFloat(document.getElementById("perlin-octaves").value);
    var contrast = parseFloat(document.getElementById("perlin-contrast").value);

    generateHeightmap(scale, amplitude, persistence, octave, contrast, rgb);
}

// BRUIT DE PERLIN =====================================================
// Cette partie du code est basée sur le pseudo-code de l'article Wikipedia sur le bruit de Perlin
// https://fr.wikipedia.org/wiki/Bruit_de_Perlin#Pseudo-code
// Il a enssuite été amélioré avec ChatGPT et des ajustements personnels
// Il est donc demandé à l'évaluateur de ne pas inclure cette portion de code dans la notation
// =====================================================================

function adjustContrast(value, factor) {
    //value = Math.max(0, Math.min(1, value));
    value = (value + 1) / 2;

    if (factor < 0) {
        return Math.pow(value, 1 - factor);
    } else {
        return Math.pow(value, 1 + factor);
    }
}

function perlinOctaves(x, y, gradients, octaves, persistence) {
    let total = 0;
    let frequency = 1;
    let amplitude = 1;
    let maxValue = 0;

    for (let i = 0; i < octaves; i++) {
        total += perlin(x * frequency, y * frequency, gradients) * amplitude;

        maxValue += amplitude;

        amplitude *= persistence;
        frequency *= 2;
    }

    return total / maxValue;
}

function smoothstep(w) {
    if (w <= 0.0) return 0.0;
    if (w >= 1.0) return 1.0;
    return w * w * (3.0 - 2.0 * w);
}

function interpolate(a0, a1, w) {
    return a0 + (a1 - a0) * w;
}

function dotGridGradient(ix, iy, x, y, gradients) {
    if (
        ix < 0 ||
        ix >= gradients[0].length ||
        iy < 0 ||
        iy >= gradients.length
    ) {
        return 0;
    }

    const Gradient = gradients;

    const dx = x - ix;
    const dy = y - iy;

    return dx * Gradient[iy][ix][0] + dy * Gradient[iy][ix][1];
}

function perlin(x, y, gradients) {
    const x0 = Math.floor(x);
    const x1 = x0 + 1;
    const y0 = Math.floor(y);
    const y1 = y0 + 1;

    const sx = x - x0;
    const sy = y - y0;

    let n0, n1, ix0, ix1, value;
    n0 = dotGridGradient(x0, y0, x, y, gradients);
    n1 = dotGridGradient(x1, y0, x, y, gradients);
    ix0 = interpolate(n0, n1, sx);
    n0 = dotGridGradient(x0, y1, x, y, gradients);
    n1 = dotGridGradient(x1, y1, x, y, gradients);
    ix1 = interpolate(n0, n1, sx);
    value = interpolate(ix0, ix1, sy);

    return value;
}

function generateGradients(gridWidth, gridHeight) {
    const gradients = [];

    for (let y = 0; y <= gridHeight; y++) {
        const row = [];
        for (let x = 0; x <= gridWidth; x++) {
            const angle = Math.random() * 2 * Math.PI;

            const gradient = [Math.cos(angle), Math.sin(angle)];
            row.push(gradient);
        }
        gradients.push(row);
    }

    return gradients;
}

// =====================================================
// FIN DU BRUIT DE PERLIN
// =====================================================

export function disposeAll() {
    runAnimation = false;
    requestAnimFrame(() => {});

    // détacher les écouteurs
    canvas.onmousedown = null;
    document.onmouseup = null;
    document.onmousemove = null;
    canvas.onwheel = null;

    // libérer chaque objet chargé
    for (const key in OBJ) {
        const o = OBJ[key];

        // supprimer buffers de géométrie
        if (o.mesh) {
            const m = o.mesh;
            if (m.vertexBuffer) gl.deleteBuffer(m.vertexBuffer);
            if (m.normalBuffer) gl.deleteBuffer(m.normalBuffer);
            if (m.textureBuffer) gl.deleteBuffer(m.textureBuffer);
            if (m.indexBuffer) gl.deleteBuffer(m.indexBuffer);
            if (m.heightmap) gl.deleteTexture(m.heightmap);
        }

        // supprimer shaders et programme
        if (o.shader) gl.deleteProgram(o.shader);
        if (o.vshader) gl.deleteShader(o.vshader);
        if (o.fshader) gl.deleteShader(o.fshader);
    }

    sceneObjects = [];
    selectedObject = null;

    selectorElem = null;
    posXElem = null;
    posYElem = null;
    posZElem = null;
    rotXElem = null;
    rotYElem = null;
    rotZElem = null;
    colorElem = null;
    wireframeElem = null;
    textureElem = null;
    normalElem = null;
    amplElem = null;
    resolutionElem = null;

    // réinitialiser l’état
    OBJ = {};
    mvMatrix = mat4.create();
    pMatrix = mat4.create();
    rotMatrix = mat4.create();
    distCENTER = null;
    gl = null;
    canvas = null;
}
